import React, { useRef } from "react";
import { matchPath } from "react-router";
import { connect } from "react-redux";
import {
  loginModelOpen,
  isAuth,
  logout,
  fetchUserDetails,
  start_loader,
  stop_loader,
  updateUserdataRedex,
  setCondition,
  setMenuCondition,
  healthCondition,
  fetchNotifications,
  readNotifications,
  confirmNotifications,
  updateNotification,
  warningBanner,
  changeCMSMode,
  updateUserChallengeTag,
  changeCMSGroupMode,
  getFooter,
  getFeatures,
  fetchConditionRelationships,
  setExploreConditions,
  gotoStep,
  clearRegisterFormUpdate,
  checkMenuData,
  openPolicy,
  savePolicy,
  getCountriesList,
  getCountOfData,
  getFaqContent,
  getURLCondition,
  switchAccount,
  fetchUserOtherDetails,
  masterUserDetails,
  teensOnBeam,
  isTakeTestClicked,
  fitnessTestForm,
  fitnessTestModalOpen,
  getUserFitnessTestScore,
  conditionModel,
  isClinicianSession,
  getConditionBanner,
  getBlogTags,
  getBlogsTitle
} from "../actions";
import LoginComponent from "../_components/LoginPage/LoginComponent";
import ForgotPasswordComponent from "../_components/LoginPage/ForgotPasswordComponent";
import WorkoutSchedulePopup from "../_components/WorkoutsPage/workoutSchedulePopup";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import Modal from "react-responsive-modal";
import * as constand from "../constant";
import { ImageTag } from "../tags";
import CookieConsent, { Cookies } from "react-cookie-consent";
import CffBanner from "../_components/HomePage/CffBanner";
import { createRef } from "react";
import ChallengingModal from "../_components/HomePage/ChallengingModal";
import { commonService } from "../_services";
import { Helmet } from "react-helmet";
import ConfirmationPopup from "../_components/Common/ConfirmationPopup";
import ClinicConfirmationPopup from "../_components/Common/ClinicConfirmationPopup"
import ConditionalModalComponent from "../_components/Common/ConditionalModalComponent";
import LandingModalComponent from "../_components/Common/LandingModalComponent";
import moment from 'moment';
import ClinicianSessionPopup from "../_components/Common/ClinicianSessionPopup";

const MENO_CONDITION = constand.MENO_CONDITION;
const KIDNEY_CONDITION = constand.KR_CONDITION.replace(/ /g, '-');
var accountAriaExpand = true;
class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      aboutAriaExpand: false,
      condition: '', //constand.CONDITION,
      is_menu_open: false,
      header_open: false,
      condition_dd_open: false,
      maintance_model: false,
      selected_notification: {},
      notification: [],
      userDetails: [],
      active_bell: false,
      currentPageName: '',
      isAdmin: false,
      isOwner: false,
      view: false,
      Filters: '',
      showLandingPopup: false,
      onDemandBody: [],
      blogCategories: [],
      blogTags: [],
      resourceAriaExpand: false,
      get_condition: ''
    };
    //  this.conditonClassList = [...constand.CONDITION_CLASS_LIST];
    this.loginClick = this.loginClick.bind(this);
    this.logoutClick = this.logoutClick.bind(this);
    this.changeDrowndownArrow = this.changeDrowndownArrow.bind(this);
    this.changeHeaderClass = this.changeHeaderClass.bind(this);
    this.changeConditionClass = this.changeConditionClass.bind(this);
    this.getConditionPopup = this.getConditionPopup.bind(this);
    this.maintance_model_state = this.maintance_model_state.bind(this);
    this.open = false;
    //  this.conditonClassList = [...constand.CONDITION_CLASS_LIST];
    //this.returnClass = this.conditonClassList.reverse();
    this.aboutRef = React.createRef();
    this.isTestTakenToday = false;
  }

  componentWillReceiveProps(props) {
    //  this.conditonClassList = [...constand.CONDITION_CLASS_LIST];
  }

  /*  getColorClass(key) {
     if (this.returnClass.length > 0)
       return this.returnClass[key];
   } */
  componentWillMount = () => {
    this.props.getBlogsTitle();

  }
  componentDidMount() {
    //this.getOnDemandList();
    this.props.getURLCondition();
    this.props.getFaqContent();
    console.log('this.props.match.params', this.props)
    this.props.getCountriesList()
    this.props.gotoStep(-1); //to clear the signup steps
    this.props.clearRegisterFormUpdate(); //to clear the signup steps
    this.getConditions();
    this.props.fetchConditionRelationships();
    this.props.warningBanner();
    this.props.isAuth();
    this.props.teensOnBeam();
    this.props.getBlogTags()
      .then(response => {
        this.setState({ blogCategories: response.categories.filter(tag=>tag.value=="help" ||tag.value=="safety" || tag.value=="education" )

         });
        this.setState({ blogTags: response.tags });
      })
      .catch(error => {
        console.error('Error fetching blog tags:', error);
      });
    this.is_auth = this.props.is_auth;

    var menuCondition = Cookies.get('condition') ? Cookies.get('condition') : this.props.menu_condition;

    if (this.props.is_auth) {
      this.getUserDetail(commonService.replaceChar(menuCondition, true));
      this.props.getUserFitnessTestScore();
    } else {
      this.props.getConditionBanner(commonService.replaceChar(menuCondition, true))
    }

    var authData = JSON.parse(sessionStorage.getItem('userDetails'));
    var createmode;
    if (authData && authData.isStudyLeader) {
      createmode = (authData.SLCondition.indexOf(commonService.replaceChar(menuCondition, true)) != -1 && JSON.parse(sessionStorage.getItem('isCreateMode'))) ? true : false;
    }
    else
      createmode = JSON.parse(sessionStorage.getItem('isCreateMode')) ? true : false;

    if (JSON.parse(localStorage.getItem('user'))) {
      var user = JSON.parse(localStorage.getItem('user'));
      setTimeout(() => {
        this.setState({
          isAdmin: user.adminDetails,
          isOwner: user.ownerdetails
        })
      }, 300)
    }
    console.log('CrEATEviji', createmode)
    this.props.changeCMSMode(createmode);

    setInterval(async () => {
      if (this.props.is_auth) {
        this.fetchNotifications();
      }
    }, constand.ASYNIC_NOTIFICATION_CALL_TIME);
    this.showForFirstTime();
    var headerUrl = this.props.history.location.pathname;
    this.setState({ headerUrl: headerUrl })
    if (this.props.history.location.search && this.props.history.location.search.indexOf('token=') !== -1) {
      var splittedToken = this.props.history.location.search.split('token=')[1];
      var temp = { token: splittedToken ? splittedToken.replace('%20', ' ') : '' }
      sessionStorage.setItem('userAuthToken', JSON.stringify(temp));
      this.props.isAuth();
      this.getUserDetail(commonService.replaceChar(menuCondition, true));
    }
    this.props.getFooter(commonService.replaceChar(menuCondition, true))
    this.savePageUrl(headerUrl);

    /*  if (this.props.url_condition) {
       console.log('this.props.url_condition',this.props.url_condition)
       console.log('header-props',this.props)
      // this.props.history.push();
     } */
  }

  getOnDemandList = () => {
    let dataObj = {
      keywords: "",
      seeMoreWorkouts: false
    };
    let condition = (Cookies.get('condition') != 'undefined' && Cookies.get('condition')) ? Cookies.get('condition').toLowerCase() : constand.KR_CONDITION;
    this.props.ondemandWorkoutList(dataObj, condition).then(
      responseData => {
        if (responseData.success) {
          let onDemandWorkouts = responseData.onDemandWorkouts;
          this.props.setBodyWorkoutJSON(onDemandWorkouts.BodySection)
          this.setState({ onDemandBody: onDemandWorkouts.BodySection }, function () {
            this.getBodySectionSectionList()
          })
        }
      });
  }

  /* Body section workout list. */
  getBodySectionSectionList = () => {
    let me = this
    let condition = (Cookies.get('condition') != 'undefined' && Cookies.get('condition')) ? Cookies.get('condition').toLowerCase() : constand.KR_CONDITION;
    this.state.onDemandBody && this.state.onDemandBody.length && this.state.onDemandBody.map((bodyWorkout, key) => {
      let workouList = { workoutArray: bodyWorkout }
      me.props.getBodyWorkoutList(workouList, condition)
    })
  }

  componentWillReceiveProps(nextProps) {
    let get_userDetails = JSON.parse(sessionStorage.getItem("userDetails"));

    JSON.parse(sessionStorage.getItem("userDetails"))
      ? this.setState({
        get_condition: get_userDetails.Tags[0]?.tag,
      })
      : this.setState({
        get_condition: "",
      });
    var headerUrl = nextProps.history.location.pathname;
    console.log('headerUrl', headerUrl)
    // if(this.state.headerUrl!=headerUrl){
    var splitter = headerUrl.split('/')[1];
    this.setState({ currentPageName: splitter })
    //}
    var createmode = JSON.parse(sessionStorage.getItem('isCreateMode')) ? true : false;
    // this.props.changeCMSMode(createmode);
    if (this.props.init_condition == '' && this.props.init_condition != nextProps.init_condition) {
      if (Cookies.get('condition')) {
        if (nextProps.init_condition != commonService.replaceChar(Cookies.get('condition'), false)) {
          this.props.getCountOfData(commonService.replaceChar(Cookies.get('condition'), false));
        }
        else {
          this.props.getCountOfData(commonService.replaceChar(nextProps.init_condition, false));
        }
      }
    }
    if (!this.props.is_auth) {
      sessionStorage.setItem("locationHistory", JSON.stringify(headerUrl))
    } else {
      let authData = JSON.parse(sessionStorage.getItem('userDetails')) || this.props.logged_userData;
      this.isClinicianUser(authData);
    }
    if (this.props.is_auth && this.props.is_test_taken_today) {
      this.props.getUserFitnessTestScore();
      this.checkTestTakenToday();
    }
    if (this.props.is_auth && this.props.is_test_taken_today) {
      this.props.getUserFitnessTestScore();
      this.checkTestTakenToday();
    }

    /* if (Cookies.get('condition') && nextProps.init_condition != commonService.replaceChar(Cookies.get('condition'), false)) {
      Cookies.set('condition', nextProps.init_condition);
    } */
  }
  /**
   * set first time user visit
   */
  showForFirstTime() {
    var firstTimeUser = sessionStorage.getItem("firstTimeUser");
    if (parseInt(firstTimeUser) !== 1) {
      //this.maintance_model_state(true);
      sessionStorage.setItem("firstTimeUser", 1);
    }
  }
  maintance_model_state(state) {
    this.props.conditionModel(state)
    this.setState({ maintance_model: state });
  }

  onCloseModal() { }

  changeDrowndownArrow() {
    if (this.state.is_menu_open === true) {
      this.setState({ is_menu_open: false });
    } else {
      this.setState({ is_menu_open: true });
    }
  }

  changeHeaderClass(url) {
    this.setState({ condition_dd_open: false });
    if (this.state.header_open === true) {
      this.setState({ header_open: false });
    } else {
      this.setState({ header_open: true });
    }
    if (url) {
      this.savePageUrl(url);
    }
  }

  savePageUrl = (url) => {
    console.log('savePageUrl', url)
    if (url) {
      var pathnameTemp = url;

      Cookies.set("current-page-url", pathnameTemp);
    }
  }

  changeConditionClass() {
    this.setState({ header_open: false });
    if (this.state.condition_dd_open === true) {
      this.setState({ condition_dd_open: false });
    } else {
      this.setState({ condition_dd_open: true });
    }
  }
  getPathFromUrl(isSetcondition, conditionCheck = false) {
    console.log('getPathFromUrl')
    var pathnameTemp = this.props.location.pathname;
    console.log('location.pathname', pathnameTemp)
    var lastOccurrence = pathnameTemp.lastIndexOf('/');
    var splitPath = pathnameTemp.split('/');
    var urlCondition = pathnameTemp.substr(lastOccurrence + 1);
    var url = '';
    console.log('isSetcondition', isSetcondition)
    console.log('splitPath.length', splitPath.length)
    console.log('splitPath.length', splitPath.length)
    console.log('constand.CONDITION_LIST', constand.CONDITION_LIST.includes(commonService.replaceChar(urlCondition, true)))
    if (isSetcondition && splitPath.length == 3 && constand.CONDITION_LIST.includes(commonService.replaceChar(urlCondition, true))) {
      url = pathnameTemp.substr(0, lastOccurrence) + '/';
    }
    return url;
  }
  getConditionPopup(url, isSetcondition = false, conditions = "") {
    let authData = JSON.parse(sessionStorage.getItem('userDetails')) || this.props.logged_userData;
    console.log('authData-getConditionPopup', authData)
    if (Object.keys(authData).length && !authData.terms) {
      this.props.openPolicy(true);
    }

    console.log('url-actual', url)
    var urlPath = this.getPathFromUrl(isSetcondition, true);
    url = isSetcondition ? (urlPath || url) : url;
    console.log('url-actual1', url)
    if (!isSetcondition) {
      if (Cookies.get('condition')) {
        this.conditionalGoto(Cookies.get('condition'), url, isSetcondition);
      } else if (this.props.is_auth && this.props.init_condition) {
        this.conditionalGoto(this.props.init_condition, url, isSetcondition);
      } else {
        this.props.conditionModel(true)
        this.setState({ pageUrl: url });
      }
    } else {
      //get liveclass counts
      this.props.getCountOfData(commonService.replaceChar(conditions, false))
        .then(response => {
          console.log('getCountOfDataresponse', response)
          console.log('module_data', this.props.module_data.liveclass)
          this.conditionalGoto(conditions, url, isSetcondition);
        }, error => {
          this.conditionalGoto(conditions, url, isSetcondition);
        });
    }
  }

  loginClick() {
    Cookies.remove('condition')
    this.props.loginModelOpen(true);
  }

  conditionalGoto(condition, url, isSetcondition = false) {
    var current_url = url;
    console.log('conditionalGoto', condition)
    console.log('conditionalGoto-current_url', current_url)
    
    var formatCondition = commonService.replaceChar(condition, true);
    this.props.checkMenuData(formatCondition);
    this.props.setCondition(condition);
    this.props.setMenuCondition(condition);
    let authData = JSON.parse(sessionStorage.getItem('userDetails')) || this.props.logged_userData;
    if (condition == constand.KR_CONDITION || condition == constand.CONDITION || condition == constand.CANCER_CONDITION || condition == constand.ASTHMA_CONDITION || condition == constand.KD_YOUTH || condition == constand.CFY_CONDITION) {
      console.log('yesmatchingcondition=', url)

      if (url) {
        current_url = url + formatCondition;
        if (url.toLowerCase().includes('liveclasses') && (this.props.module_data.liveclass == 0 && ((authData && !(authData.isCreator || (authData.isStudyLeader && authData.SLCondition.indexOf(commonService.replaceChar(condition, true)) != -1)))))) {
          current_url = '/on-demand/' + formatCondition;
        }
      } else {
        current_url = '/' + formatCondition;
      }
      console.log('if-current_url=', current_url)

      const { from } = { from: { pathname: current_url } };
      this.props.history.push(from);
    } else {
      console.log('nomatchingcondition=', url)
      var pathnameTemp = this.props.location.pathname;
      console.log('location.pathname', pathnameTemp)
      var splitPath = pathnameTemp.split('/');
      if (splitPath.length > 3) {
        console.log('ifsplitpath=')

        //redirect to listing page other than main listing page
        current_url = '/on-demand/' + formatCondition;
        if (this.props.module_data.liveclass || ((authData && (authData.isCreator || (authData.isStudyLeader && authData.SLCondition.indexOf(commonService.replaceChar(condition, true)) != -1)))))
          current_url = '/liveClasses/' + formatCondition;

        //irehab my-schedule my-group menu access
        if (condition.includes('Research') && constand.SP_MENU.includes(url.replace(/\//g, ""))) {
          current_url = url + formatCondition
        }
        const { from } = { from: { pathname: current_url } };
        this.props.history.push(from);
      } else {
        console.log('elsesplitpath=')

        //  current_url = '/on-demand/' + formatCondition;
        current_url = url + formatCondition;
        console.log('includesof', url.toLowerCase().includes('liveclasses'))
        console.log('liveclasscount=', this.props.module_data.liveclass)
        if (url.toLowerCase().includes('liveclasses') && this.props.module_data.liveclass == 0 && ((authData && !(authData.isCreator || (authData.isStudyLeader && authData.SLCondition.indexOf(commonService.replaceChar(condition, true)) != -1))))) {
          current_url = '/on-demand/' + formatCondition;
        }
        console.log('includesof-current_url=', current_url)
        //current_url = '/liveClasses/' + formatCondition;

        //irehab my-schedule my-group menu access
        if (condition.includes('Research') && constand.SP_MENU.includes(url.replace(/\//g, ""))) {
          current_url = url + formatCondition
        }
        const { from } = { from: { pathname: current_url } };
        this.props.history.push(from);
      }
    }
    Cookies.set("condition", formatCondition);
    this.savePageUrl(current_url);
    this.props.conditionModel(false)
    this.setState({ condition: formatCondition, header_open: false })

  }

  logoutClick() {
    Cookies.remove('condition')
    this.props.updateNotification({ notification: [], userDetails: [] });
    this.props.logout();
    this.props.isAuth();
    /* const { from } = { from: { pathname: "/home" } };
    this.props.history.push(from); */
    window.location.href = "/";
  }

  getUserDetail = (menuCondition) => {
    this.props.fetchUserDetails().then(
      response => {
        this.props.fetchUserOtherDetails().then(() => {
          console.log('getuserdetails-header')
          let authData = JSON.parse(sessionStorage.getItem('userDetails')) || this.props.logged_userData;
          if (!authData.masterUserID) {
            sessionStorage.setItem('masterUserDetails', JSON.stringify(this.props.logged_userData))
          }
          this.props.setExploreConditions(authData.UserConditions, this.props.healthcondition_list)
          //var beamChallenge = this.props.match.params.beamchallenging && this.props.match.params.beamchallenging.includes('keepbeaming-signup') ? 'keepbeaming-signup' : '';
          //sessionStorage.setItem('beamchallenging', beamChallenge)
          let temp = commonService.returnTagName('condition', constand.KR_CONDITION, this.props.logged_userData.UserConditions);
          if (sessionStorage.getItem('beamchallenging') && this.props.is_auth && temp) {
            this.props.updateUserChallengeTag();
          }

          this.fetchNotifications();
          this.props.getFeatures()
          //this.getBeamer();
          if (!authData.terms && this.state.currentPageName != 'terms') {
            this.props.openPolicy(true);
          }
          this.props.getCountOfData(menuCondition);

          this.props.getConditionBanner(menuCondition);

          let masterUserDetails = JSON.parse(sessionStorage.getItem('masterUserDetails'));
          if (masterUserDetails && authData) {
            let checkChild = masterUserDetails.childUser && masterUserDetails.childUser.length > 0 && masterUserDetails.childUser.filter((o) => { return o.id == authData.id });
            if (authData.masterUserID && (!checkChild || checkChild.length <= 0)) {
              masterUserDetails.childUser.push(authData)
              sessionStorage.setItem('masterUserDetails', JSON.stringify(masterUserDetails))
            }
            this.props.masterUserDetails(masterUserDetails)
          }
          this.setState({ showLandingPopup: true })
          if (this.props.is_auth) {
            this.isClinicianUser(authData);
          }
        })
      },
      error => {
        console.log('fetchUserDetails-err', error)
        /* if (error === "Unauthorized") {
          this.logoutClick()
          toast.error(error + " :Token expired. Please login again.");
        } else */
        toast.error(error);
      }
    );
  }

  isClinicianUser = (authData) => {
    let condition = (Cookies.get('condition') != 'undefined' && Cookies.get('condition')) ? Cookies.get('condition').toLowerCase() : constand.KR_CONDITION;
    let usesCondition = [];
    let isClinician = [];
    usesCondition = authData.UserConditions;
    isClinician = usesCondition && usesCondition.length && usesCondition.filter(item => item.conditionRelationship && item.conditionRelationship.toLowerCase().includes(constand.CLINICIANS));

    if (authData && Object.keys(authData).length && !condition.includes('research') && isClinician && isClinician.length) {
      this.props.isClinicianSession(true);
    } else {
      this.props.isClinicianSession(false);
    }
  }

  getConditions() {
    this.props.healthCondition().then(
      response => {
        this.props.setExploreConditions(this.props.logged_userData.UserConditions, this.props.healthcondition_list)
      },
      error => {
        toast.error(error);
      }
    );
  }

  fetchNotifications() {
    this.props.fetchNotifications().then(
      response => {
        let notification = (response && response.notification) ? response.notification : [];
        let alert_status = (response && response.count > 0) ? true : false;
        let userDetails = (response && response.userDetails) ? response.userDetails : [];
        this.setState({ notification: notification, userDetails: userDetails, active_bell: alert_status });
        setTimeout(() => {
          this.setState({ active_bell: false });
        }, constand.BELL_ALERT_TIMEOUT);
      },
      error => {
        /* if (error === 'Unauthorized') {
          this.logoutClick()
          toast.error(error + " :Token expired. Please login again.");
        } else */
        toast.error(error);
      }
    );
  }

  readNotifications(item) {
    let params = { notifyId: item.id };
    this.props.readNotifications(params).then(
      response => {
        this.spliceGroupContent(item.id);
      },
      error => {
        toast.error(error);
      }
    );
  }

  confirmNotifications(isAccept, notifyId) {
    let params = {
      isAccept: isAccept,
      notifyId: notifyId
    };
    this.props.confirmNotifications(params).then(
      response => {
        this.spliceGroupContent(notifyId);
        toast.success(response.message);
      },
      error => {
        toast.error(error);
      }
    );
  }

  viewNotification(key) {

    let temp_notification = [...this.props.notification];
    temp_notification[key].extented = (temp_notification[key].extented === true) ? false : true;
    let current_notification = temp_notification[key];
    let squalizeObj = { notification: temp_notification, userDetails: this.props.userDetails };
    this.setState({ selected_notification: current_notification, notification: temp_notification });
    this.props.updateNotification(squalizeObj);
  }

  gotoGroup(item) {
    this.changeHeaderClass();
    if (item.Community && item.Community.community_name) {
      const { from } = { from: { pathname: ("/group/feed/" + item.Community.community_name + "/" + commonService.replaceChar(Cookies.get('condition'), false)) } };
      this.props.history.push(from);
    } else if (item.Workout && item.Workout.title) {
      const { from } = { from: { pathname: ("/detail/" + item.Workout.id + "/" + commonService.replaceChar(Cookies.get('condition'), false)) } };
      this.props.history.push(from);
    }
  }

  spliceGroupContent(notifyId) {
    let temp_notification = [...this.props.notification];
    let temp_userDetail = [...this.props.userDetails];
    let index = temp_notification.findIndex(x => parseInt(x.id) === parseInt(notifyId));
    if (index > -1) {
      temp_notification.splice(index, 1);
      temp_userDetail.splice(index, 1);
    }
    let squalizeObj = { notification: temp_notification, userDetails: temp_userDetail };
    this.setState({ notification: temp_notification });
    this.props.updateNotification(squalizeObj)
  }

  /**
   * fitness test notification
   * @param {*} item
   */
  takeTest = (item) => {
    let takeTestFlagObj = {
      isTakeTestClicked: true,
      clickedByTestPopup: false
    }
    this.props.isTakeTestClicked(takeTestFlagObj);
    sessionStorage.setItem("fitnessPopupClosed", false)
    this.readNotifications(item)
    this.props.fitnessTestForm().then(response => {
      this.props.fitnessTestModalOpen(true);
    }, error => {

    });
  }

  _renderNotification() {
    this.checkTestTakenToday()
    return (<li>
      <h5 className="col-md-12 font-14 black-txt font-qmedium p-t-5 p-b-5 m-b-0  border-bottom">
        Notifications
      </h5>
      <ul className="noti_list">
        {this.props.notification && this.props.notification.map((item, key) => {
          var reference = item.Room ? (item.Room.Attendees && item.Room.Attendees.length > 0 ? item.Room.Attendees[0].reference : '#') : '';
          var prequest = (item.Room && item.Room.Questionnaire) ? item.Room.Questionnaire.preQuestionnaire : ''
          return (
            <li key={key} className="border-bottom">
              <div className=" col-md-12 p-t-10 p-b-10 ">
                <div className=" row">
                  <div className="col-md-3 col-sm-3 col-xs-3">
                    <div className="notify-img text-center">
                      <ImageTag width="36" className="img-fluid rounded-circle"
                        src={(this.props.userDetails[key].profilePic) ? constand.PROFILE_IMAGE_PATH + this.props.userDetails[key].profilePic : constand.WEB_IMAGES + 'no-profile-pic.png'}
                      />
                    </div>
                  </div>
                  <div className="col-md-9 col-sm-9 col-xs-9 p-0 row">
                    <span
                      className="pull-left ltext p-l-0 black-txt font-14 font-qregular"
                    >
                      {(item.type === 'liveclassRemind' || item.type === 'ondemandRemind') && item.bespokeMsg}

                      {(item.type === 'joinrequest' || item.type === 'join') && this.processGroupMsg(item, 'group')}
                      {(item.type == 'fileUploadSuccess' || item.type == 'fileUploadFail') && this.processGroupMsg(item, 'file')}

                      {item.type == 'fitnessTest' && item.bespokeMsg}
                    </span>
                    {" "}
                    <span
                      className="p-0 pull-right text-right"
                    >
                      <i className="fa fa-times pointer text-muted" aria-hidden="true" onClick={() => this.readNotifications(item)}></i>
                      {/* <i className="fa fa-ellipsis-v pointer" aria-hidden="true" onClick={()=>this.viewNotification(key)}></i> */}
                    </span>
                    {/*<div className="w-100 text-left m-t-10 m-b-10">*/}
                    {(item.type === 'joinrequest' && item.reqUserId) &&
                      <React.Fragment>
                        <button className="btn  dblog_btn notifify_confirm_btn font-12 font-medium btn-purple m-r-5" onClick={() => this.confirmNotifications(1, item.id)}>
                          Accept
                        </button>
                        <button className="btn deny_btn black-txt font-12 font-medium" onClick={() => this.confirmNotifications(0, item.id)}>
                          Reject
                        </button>
                      </React.Fragment>}
                    {item.type === 'liveclassRemind' &&
                      <React.Fragment>
                        {prequest != '' && <a className="btn preclass_btn notifify_confirm_btn font-12 font-medium btn-purple m-r-5" href={prequest} target="_blank" > pre-class survey </a>}
                        {/* <button className="btn  dblog_btn notifify_confirm_btn font-12 font-medium btn-purple m-r-5" onClick={() => this.readNotifications(item)}>
                          pre-class survey
                  </button> */}
                        {/* <button className="btn deny_btn black-txt font-12 font-medium" onClick={() => this.confirmNotifications(0, item.id)}>
                          go to class
                  </button> */}
                        <a className="btn deny_btn black-txt font-12 font-medium" href={reference} target="_blank" > go to class </a>
                      </React.Fragment>
                    }
                    {
                      item.type === 'ondemandRemind' &&
                      <React.Fragment>
                        <a className="btn deny_btn black-txt font-12 font-medium" href={"/detail/" + item.workoutId + "/" + commonService.replaceChar(this.state.condition, false)} >start class</a>

                        {/* <button className="btn deny_btn black-txt font-12 font-medium" onClick={() => this.confirmNotifications(0, item.id)}>
                          start class
                   </button> */}
                      </React.Fragment>
                    }
                    {
                      item.type === 'fitnessTest' &&
                      <React.Fragment>
                        <button disabled={this.isTestTakenToday || this.props.is_test_taken_today} className="btn  dblog_btn notifify_confirm_btn font-12 font-medium btn-purple m-r-5 take-test-tooltip" onClick={() => this.takeTest(item)}>
                          Take Test
                        </button>
                        <button className="btn deny_btn black-txt font-12 font-medium" onClick={() => this.readNotifications(item)} >
                          Not Now
                        </button>
                      </React.Fragment>
                    }
                    {/* </div> */}
                  </div>
                </div>
              </div>
            </li>)
        })}
      </ul>
    </li>);
  }

  processGroupMsg(item, type) {
    let return_msg;
    let raw_message = (item.bespokeMsg) ? item.bespokeMsg : '';
    switch (type) {
      case 'group':
        let group_name = (item.Community && item.Community.community_name) ? item.Community.community_name : '';
        var row_message = raw_message.split(group_name);
        if (row_message.length > 1) {
          return_msg = <React.Fragment>{row_message[0]}<u className="pointer font-semibold purplefont" onClick={() => this.gotoGroup(item)}>{group_name}</u>{row_message[1]}</React.Fragment>;
        } else {
          return_msg = row_message[0];
        }
        break;
      case 'file':
        let workout_name = (item.Workout && item.Workout.title) ? item.Workout.title : '';
        var row_message = raw_message.split(workout_name);
        if (row_message.length > 1) {
          return_msg = <React.Fragment>{row_message[0]}<u className="pointer font-semibold purplefont" onClick={() => this.gotoGroup(item)}>{workout_name}</u>{row_message[1]}</React.Fragment>;
        } else {
          return_msg = row_message[0];
        }
        break;
    }
    return return_msg;
  }

  checkTestTakenToday = () => {
    const userTestScoreList = this.props.userTestScoreList.length && Array.from(this.props.userTestScoreList);
    const mostRecentDate = commonService.getMostRecentDate(userTestScoreList);
    this.isTestTakenToday = commonService.checkIsTodayDate(mostRecentDate);
  }


  _renderMobileNotification() {
    this.checkTestTakenToday()
    return (<ul className={this.state.notifyAriaExpand ? "dropdown-menu noti_list show" : "dropdown-menu noti_list"} >
      {this.props.notification && this.props.notification.map((item, key) => {
        return (
          <li key={key}>
            <div className="notifi_list">
              <div className=" col-md-12 p-t-10 p-b-10 border-bottom">
                <div className=" row">
                  <div className="col-10">
                    <span className="font-14 font-book noti-text pull-left">

                      {(item.type === 'liveclassRemind' || item.type === 'ondemandRemind') && item.bespokeMsg}

                      {(item.type === 'joinrequest' || item.type === 'join') && this.processGroupMsg(item, 'group')}
                      {(item.type == 'fileUploadSuccess' || item.type == 'fileUploadFail') && this.processGroupMsg(item, 'file')}
                    </span>{" "}
                  </div>
                  <div className="col-2 p-0">
                    {(item.type === 'joinrequest' && item.reqUserId) &&
                      <React.Fragment>
                        <span className="text-right green-batch"><img src={constand.WEB_IMAGES + "notitick.png"} onClick={() => this.confirmNotifications(1, item.id)} /></span>
                        <span className="text-right red-batch "><img src={constand.WEB_IMAGES + "cancel.png"} onClick={() => this.confirmNotifications(0, item.id)} /></span>
                      </React.Fragment>
                    }
                  </div>
                  <div>
                    {item.type === 'fitnessTest' &&
                      <React.Fragment>
                        <span className="font-14 font-book noti-text pull-left">
                          {item.bespokeMsg}
                          <button disabled={this.isTestTakenToday || this.props.is_test_taken_today} className="btn dblog_btn notifify_confirm_btn font-12 font-medium btn-purple m-r-5" onClick={() => this.takeTest(item)}>
                            Take Test
                          </button>
                          <button className="btn deny_btn black-txt font-12 font-medium" onClick={() => this.readNotifications(item)} >
                            Not Now
                          </button>
                        </span>
                      </React.Fragment>
                    }
                  </div>
                </div>
                <i className="fa fa-times pointer" aria-hidden="true" onClick={() => this.readNotifications(item)}></i>
              </div>
            </div>
          </li>)
      })}</ul>);
  }

  handleClickRef(ref) {
    console.log('handleClick-ref', ref)
    switch (ref) {
      case 'aboutRef':
        var expa = this.state.aboutAriaExpand;
        this.setState({ aboutAriaExpand: !expa })
        break;
      case 'workRef':
        var expa = this.state.workAriaExpand;
        this.setState({ workAriaExpand: !expa })
        break;
      case 'notificationRef':
        var expa = this.state.notifyAriaExpand;
        this.setState({ notifyAriaExpand: !expa })
        break;
      case 'accountRef':
        var expa = this.state.accountAriaExpand;
        this.setState({ accountAriaExpand: !expa })
        break;
      case 'resourceRef':
        var expa = this.state.resourceAriaExpand;
        this.setState({ resourceAriaExpand: !expa })
        break;
    }
    /* this.refs[ref].scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    }); */
    var me = this;
    setTimeout(() => {
      console.log('Hello, World!', ref);
      me.refs[ref].scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }, 500);


  }

  saveUserPolicy = (terms) => {
    this.setState({ submitted: true });
    if (terms) {
      this.props.savePolicy(terms).then(response => {
        toast.success(response.message)
        this.props.openPolicy(false);
        let authData = this.props.logged_userData || JSON.parse(sessionStorage.getItem('userDetails'));
        let newValue = authData;
        newValue['terms'] = terms;
        this.props.updateUserdataRedex(newValue);

      }, error => {
        toast.error(error)
      })
    }
  }

  handleCheckboxChange = (e) => //for twoway binding checkbox
  {
    /*  const { name } = e.target;
     this.state.terms = !this.state.terms; */
    this.setState({ terms: !this.state.terms })
  }

  closeConditionModal = () => {
    this.props.conditionModel(false)
  }

  render() {
    let condition = (Cookies.get('condition') != 'undefined' && Cookies.get('condition')) ? Cookies.get('condition').toLowerCase() : constand.KR_CONDITION;
    let authData = this.props.logged_userData || JSON.parse(sessionStorage.getItem('userDetails'));
    let masterUserDetails = JSON.parse(sessionStorage.getItem('masterUserDetails'));
    let logoUrl = '/';
    let headerUrl = this.props.history.location.pathname;
    let menuCondition = Cookies.get('condition') ? Cookies.get('condition') : this.props.menu_condition;
    let cookieCondition = Cookies.get('condition') ? commonService.replaceChar(Cookies.get('condition'), true) : commonService.replaceChar(this.props.init_condition, true);
    let closeBannerCookie = cookieCondition ? 'closeBanner' + commonService.replaceSpaceToChar(cookieCondition.toLowerCase(), '') : '';
    console.log('cookieCondition', cookieCondition)
    console.log('closeBannerCookie', closeBannerCookie)
    console.log('this.props.close_banner', this.props.close_banner)
    console.log('this.props.close_banner type=', typeof this.props.close_banner[closeBannerCookie])
    console.log('this.props.closeBannerCookie', (Object.keys(this.props.close_banner).length > 0 && (!this.props.close_banner[closeBannerCookie] || typeof this.props.close_banner[closeBannerCookie] == 'undefined')))

    if (authData && authData.isStudyLeader) {
      logoUrl = '/on-demand/' + commonService.replaceChar(cookieCondition, false);
    } else if (authData && (authData.isGroupLeader || authData.isStudyInstructor)) {
      logoUrl = '/groups/' + commonService.replaceChar(cookieCondition, false);
    } else if (authData && authData.isStudyUser) {
      let community = authData.Members.length ? authData.Members[0].Community.community_name : '';
      logoUrl = '/group/feed/' + community + '/' + commonService.replaceChar(cookieCondition, false);
    }
    console.log('header-this.props.history', this.props.history)
    let currentPath = this.props.history ? this.props.history.location.pathname : '/';
    console.log("currentPath", currentPath, currentPath.indexOf('/reset'))
    currentPath = currentPath.indexOf('/reset') != -1 ? '/' : currentPath;
    console.log("currentPath1", currentPath)
    let logo_name = "Kidney-Beam-Logo.png";
    if (authData && authData.isStudyUser) {
      let trialName = (commonService.replaceChar(cookieCondition, true).toLowerCase()).replace('research studies: ', '');
      logo_name = trialName.charAt(0).toUpperCase() + trialName.slice(1) + '-lock-up.png';
    }
    /* const accountRef = React.createRef();

    function handleClickRefLocal(ref) {
      accountAriaExpand = !accountAriaExpand;
      return ref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    } */
    var fitnessPopupClosed = JSON.parse(sessionStorage.getItem('fitnessPopupClosed'));
    if (!fitnessPopupClosed && this.props.logged_userData.isUserFitnessTest && this.props.is_auth) {
      this.props.fitnessTestModalOpen(true)
    } else if (this.props.is_fitness_test_model_open && this.props.is_auth) {
      this.props.fitnessTestModalOpen(true)
    } else {
      this.props.fitnessTestModalOpen(false)
    }

    // let cookieConditionVal = Cookies.get("condition");
    const isStudyUser = authData && authData.isStudyUser;

    const logoImage = cookieCondition === undefined
      ? (this.state.get_condition === "kidney disease" ||
          this.state.get_condition === "kidney youth" ||
          this.state.get_condition === "kidney kids")
        ? constand.S3_WEB_IMGES+"/Kidney-Beam-Logo.png"
        : constand.WEB_IMAGES+"Kidney-Beam-Logo.png"
      : (cookieCondition === "kidney disease" || cookieCondition === "kidney youth" || cookieCondition === "kidney kids")
        ? constand.S3_WEB_IMGES+"/Kidney-Beam-Logo.png"
        : constand.WEB_IMAGES+"Kidney-Beam-Logo.png";

    return (
      <React.Fragment>
        {/* beamer code disabled */}
        {/* <Helmet>
          <script type="text/javascript">{`
        var beamer_config ={
          product_id: "${process.env.REACT_APP_PRODUCT_ID}",
          filter: "${this.props.beamer_filter}",
        };
    `}
          </script>
          <script type="text/javascript" src="https://app.getbeamer.com/js/beamer-embed.js" defer="defer"></script>
        </Helmet> */}
        {/* <div className="col-md-12 text-center text-md-center mb-3 top-bar font-qregular">
          Health professionals: want to explore our research and see how we can
          work together?
        </div> */}
        <header className="header header-custom" >
          {/*
          <CookieConsent
            buttonText="Okay - I'm happy with this"
            disableStyles={true}
            buttonClasses="btn btn-orange font-medium font-14 m-t-20"
            containerClasses="cookieConsentContainer"
            expires={150}
            onAccept={({ acceptedByScrolling }) => {
              if (acceptedByScrolling) {
                // triggered if user scrolls past threshold
                //alert("Accept was triggered by user scrolling");
              } else {
                Cookies.set('Username', me.props.logged_userData.name + ' ' + me.props.logged_userData.lastName, { path: '/' })
              }
            }}
          >
            <div className="cookieTitle"><a>Cookies 🍪</a>
            </div>
            <div className="cookieDesc">
              <p>Our website uses cookies to ensure you get the best experience while you're here
              </p>
            </div>

          </CookieConsent> */}
          <div id="content"></div>

          <nav
            className={
              (matchPath(this.props.location.pathname, "/instructor/:id")
                ? "border-bottom"
                : "") +
              " navbar navbar-expand-lg navbar-light bg-white fixed-top header-with-info1 " +
              ((this.props.location.pathname === '/' || this.props.location.pathname === '/health-professionals' || this.props.warning_banner_text.length > 0)
                ? "header-with-info" : "")
            }
          >
            {(this.props.warning_banner_text.length > 0  &&
  (this.props.location.pathname === '/' || this.props.location.pathname === '/health-professionals') || commonService.replaceChar(this.props.location.pathname, true) == 
  "/"+constand.KR_CONDITION || commonService.replaceChar(this.props.location.pathname, true) == "/"+constand.KD_YOUTH) &&  (
              <div class="blue-info font-qmedium top-bar">
                {this.props.warning_banner_text.map((item, key) => {
                  return (
                    <a
                      href={item.url}
                      rel="noopener noreferrer"
                    >
                      <p> {item.text}</p>
                    </a>
                  );
                })}
              </div>
            )}
            {/* <div className="col-md-12 text-center text-md-center mb-3 top-bar font-qregular"> */}
            {/*<div class="blue-info font-qmedium top-bar">
              <p>
                Health professionals: want to explore our research and see how
                we can work together?
              </p>
            </div>*/}
            <div className="  container-fluid mx-auto pl-3 pr-3">
              {/* <div className="col-md-12 bg-purple-color loadtime-banner">
                  <p className="font-18 font-qmedium white-txt pt-3">
                    *** Beam is experiencing slow page loading speeds at the moment.  While we're working hard to fix it please give pages extra time to load and email hello@beamfeelgood.com if you're unable to get to a class. Thanks for bearing with us. *** </p>
                </div> */}
              {/* <Link className={("navbar-brand pointer ") + (authData && authData.isStudyUser ? 'w-25' : '')} to={logoUrl} >
                <img src={constand.WEB_IMAGES + logo_name} alt="beam" className={(authData && authData.isStudyUser ? 'w-100' : '')} />
              </Link> */}
              <Link
                className={`navbar-brand pointer ${isStudyUser ? "w-25" : ""}`}
                to={logoUrl}
              >
                <img
                  src={`${logoImage}`}
                  alt="beam"
                  className={isStudyUser ? "w-100" : ""}
                />
              </Link>
              {(Cookies.get('condition') || (this.props.is_auth && this.props.init_condition)) &&
                <div className="left-cyber">
                  {/* <span class="float-left for-txt font-semibold">for </span> */}
                  {/*web view*/}
                  {(!authData || (authData && !authData.isStudyUser)) &&
                    < ul className="navbar-nav ml-auto align-items-start align-items-lg-center float-left cyber-txt navbar-collapse" >
                      <li className="dropdown nav-item webmenu">
                        <a
                          className="dropdown-toggle nav-link link-scroll font-semibold navalign cyber-link"
                          role="button"
                          aria-expanded="false"
                          aria-haspopup="true"
                          href="#"
                          data-toggle="dropdown"
                        >
                          {Cookies.get('condition') && commonService.replaceChar(Cookies.get('condition'), true) || (this.props.is_auth && this.props.init_condition && commonService.replaceChar(this.props.init_condition, true))}
                          {(!cookieCondition.toLowerCase().includes('research') || (cookieCondition.toLowerCase().includes('research') && authData && authData.UserConditions && authData.UserConditions.length > 1)) &&
                             <span class="caret"></span>
                          }
                        </a>
                        {(!cookieCondition.toLowerCase().includes('research') || (cookieCondition.toLowerCase().includes('research') && authData && authData.UserConditions && authData.UserConditions.length > 1)) &&
                          <ul className="dropdown-menu cyber-menu">
                            {(this.props.is_auth && authData && authData.UserConditions && authData.UserConditions.length > 0) &&
                              <li className="nav-item">
                                <Link className="nav-link link-scroll font-medium navalign add_purple_bg top-section-condition" >
                                  My conditions
                                </Link>
                              </li>
                            }
                            {(authData && authData.UserConditions &&
                              authData.UserConditions.map((item, key) => {
                                return (
                                  <li className="nav-item" >
                                    <a
                                      className="nav-link link-scroll font-medium navalign pointer"
                                      onClick={() => {
                                        var url = ((authData.isGroupLeader || authData.isStudyLeader || authData.isStudyInstructor) && constand.SL_MENU.includes('on-demand')) ? '/on-demand/' : '/liveClasses/';

                                        this.getConditionPopup(url, true, item.Tag.tag);
                                        this.props.getFooter(item.Tag.tag)
                                        this.props.getConditionBanner(item.Tag.tag)
                                      }}
                                    >
                                      <p className="purplefont capitalize_text m-0">
                                        {item.Tag.tag}
                                      </p>
                                    </a>
                                  </li>
                                )
                              }))
                              ||
                              this.props.healthcondition_list.map((item, key) => {
                                return (
                                  <li className="nav-item" >
                                    <a
                                      className="nav-link link-scroll font-medium navalign pointer"
                                      onClick={() => {
                                        var url = '/on-demand/';
                                        this.getConditionPopup(url, true, item.tag);
                                        this.props.getFooter(item.tag)
                                        this.props.getConditionBanner(item.tag)
                                      }}
                                    >
                                      <p className="purplefont capitalize_text m-0">
                                        {item.tag}
                                      </p>
                                    </a>
                                  </li>
                                )
                              })
                            }
                            {this.props.is_auth && authData && authData.UserConditions && (this.props.healthcondition_list.length != authData.UserConditions.length) &&
                              <li className="nav-item">
                                <Link className="nav-link link-scroll font-medium navalign add_purple_bg" >
                                  Explore conditions
                                </Link>
                              </li>
                            }
                            {this.props.is_auth && authData && authData.UserConditions && (this.props.healthcondition_list.length != authData.UserConditions.length) &&
                              this.props.explore_conditions.length && this.props.explore_conditions.map((item, key) => {
                                return (
                                  <li className="nav-item" >
                                    <a
                                      className="nav-link link-scroll font-medium navalign pointer"
                                      onClick={() => {
                                        var url = '/on-demand/';
                                        this.getConditionPopup(url, true, item.tag);
                                        this.props.getFooter(item.tag)
                                        this.props.getConditionBanner(item.tag)
                                      }}
                                    >
                                      <p className="purplefont capitalize_text m-0">
                                        {item.tag}
                                      </p>
                                    </a>
                                  </li>
                                )
                              })
                            }
                          </ul>
                        }
                      </li>
                    </ul>
                  }
                  {/*mobile view*/}
                  {/* {(!authData || (authData && !authData.isStudyUser)) &&
                    < ul className="navbar-nav ml-auto align-items-start align-items-lg-center float-left cyber-txt mobile-condition-dd" >
                      <li className="nav-item">
                        <a
                          className="dropdown-toggle nav-link link-scroll font-semibold navalign cyber-link"
                          role="button"
                          aria-expanded="false"
                          aria-haspopup="true"
                          href="#"
                          onClick={this.changeConditionClass}
                        >
                          {Cookies.get('condition') && commonService.replaceChar(Cookies.get('condition'), true) || (this.props.is_auth && this.props.init_condition && commonService.replaceChar(this.props.init_condition, true))} {" "}
                          {(!cookieCondition.toLowerCase().includes('research') || (cookieCondition.toLowerCase().includes('research') && authData && authData.UserConditions && authData.UserConditions.length > 1)) &&
                            <span class=" caret"></span>
                          }
                        </a>
                      </li>
                    </ ul>
                  } */}
                  {/* {(!cookieCondition.toLowerCase().includes('research') || (cookieCondition.toLowerCase().includes('research') && authData && authData.UserConditions && authData.UserConditions.length > 1)) &&
                    <div
                      className={
                        "mobile-nav " +
                        (this.state.condition_dd_open === true ? "clicked" : " ")
                      }
                    >
                      <ul className="navbar-nav ml-auto align-items-start align-items-lg-center text-capitalize">

                        {(this.props.is_auth && authData && authData.UserConditions && authData.UserConditions.length > 0) &&
                          <li className="dropdown nav-item" >
                            <a
                              className="dropdown-toggle nav-link link-scroll font-book navalign"
                              role="button"
                              aria-expanded="false"
                              aria-haspopup="true"
                              href="#"
                              data-toggle="dropdown"

                            >
                              My Conditions{" "}
                              <i className="fa  fa-2x pull-right small-arrow fa-angle-down"></i>
                            </a>
                            <ul className="dropdown-menu">
                              {(authData && authData.UserConditions &&
                                authData.UserConditions.map((item, key) => {
                                  return (
                                    <li className="nav-item" >
                                      <Link
                                        className="nav-link link-scroll font-medium navalign"
                                        onClick={() => {
                                          var url = ((authData.isGroupLeader || authData.isStudyLeader || authData.isStudyInstructor) && constand.SL_MENU.includes('on-demand')) ? '/on-demand/' : '/liveClasses/';

                                          this.changeConditionClass();
                                          this.getConditionPopup(url, true, item.Tag.tag)
                                        }}
                                      >
                                        {item.Tag.tag}
                                      </Link>
                                    </li>
                                  )
                                })
                              )}
                            </ul>
                          </li>
                        }
                        {this.props.is_auth && authData && authData.UserConditions && (this.props.healthcondition_list.length != authData.UserConditions.length) &&
                          <li className="dropdown nav-item" >
                            <a
                              className="dropdown-toggle nav-link link-scroll font-book navalign"
                              role="button"
                              aria-expanded="false"
                              aria-haspopup="true"
                              href="#"
                              data-toggle="dropdown"

                            >
                              Explore conditions{" "}
                              <i className="fa  fa-2x pull-right small-arrow fa-angle-down"></i>
                            </a>
                            <ul className="dropdown-menu">
                              {(this.props.explore_conditions.length &&
                                this.props.explore_conditions.map((item, key) => {
                                  return (
                                    <li className="nav-item" >
                                      <Link
                                        className="nav-link link-scroll font-medium navalign"
                                        onClick={() => {
                                          var url = '/on-demand/';

                                          this.changeConditionClass();
                                          this.getConditionPopup(url, true, item.tag)
                                        }}
                                      >
                                        {item.tag}
                                      </Link>
                                    </li>
                                  )
                                })
                              )}
                            </ul>
                          </li>
                        }
                        {(!this.props.is_auth &&

                          this.props.healthcondition_list.map((item, key) => {
                            return (
                              <li className="nav-item" >
                                <Link
                                  className="nav-link link-scroll font-medium navalign"
                                  onClick={() => {
                                    var url = '/on-demand/';

                                    this.changeConditionClass();
                                    this.getConditionPopup(url, true, item.tag)
                                  }}
                                >
                                  {item.tag}
                                </Link>
                              </li>
                            )
                          })
                        )
                        }
                      </ul>
                    </div>
                  } */}
                </div>
              }
              <button
                className={
                  "navbar-toggler menu " +
                  (this.state.header_open === true ? "clicked" : " ")
                }
                type="button"
                data-toggle="collapse"
                data-target="#navbarNavAltMarkup"
                aria-controls="navbarNavAltMarkup"
                aria-expanded="false"
                aria-label="Toggle navigation"
                onClick={this.changeHeaderClass}
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              {/* start mobile view */}
              <div
                className={
                  "mobile-nav " +
                  (this.state.header_open === true ? "clicked" : " ")
                }

              >
                <ul className="navbar-nav ml-auto align-items-start align-items-lg-center">
                  {!this.props.is_auth && (
                    <li className="nav-item cursor">
                      <span
                        className="nav-link navalign font-book  pointer"
                        onClick={() => { this.changeHeaderClass(); this.loginClick(); }}
                      >
                        Sign In
                      </span>
                    </li>
                  )}
                  {this.props.is_auth &&
                    <li className="dropdown nav-item profile">
                      <Link className="btn navbar-btn btn-shadow font-medium font-14 btn-gradient button-style w-100 my-beam" to={"/account/dashboard/schedule/" + commonService.replaceChar(menuCondition, false)}>My Kidney Beam
                      </Link>
                    </li>
                  }

                  {(this.props.is_auth && authData && authData.UserConditions && authData.UserConditions.length > 0) &&
                    <>
                      <li className="dropdown nav-item text-capitalize" >
                        <a
                          className="dropdown-toggle nav-link link-scroll font-book navalign"
                          role="button"
                          aria-expanded="false"
                          aria-haspopup="true"
                          href="#"
                          data-toggle="dropdown"

                        >
                          My Conditions{" "}
                          <i className="fa  fa-2x pull-right small-arrow fa-angle-down"></i>
                        </a>
                        <ul className="dropdown-menu">
                          {(authData && authData.UserConditions &&
                            authData.UserConditions.map((item, key) => {
                              return (
                                <li className="nav-item" >
                                  <a
                                    className="nav-link link-scroll font-medium navalign pointer"
                                    onClick={() => {
                                      var url = ((authData.isGroupLeader || authData.isStudyLeader || authData.isStudyInstructor) && constand.SL_MENU.includes('on-demand')) ? '/on-demand/' : '/liveClasses/';

                                      this.changeHeaderClass();
                                      this.getConditionPopup(url, true, item.Tag.tag);
                                      this.props.getConditionBanner(item.Tag.tag)

                                    }}
                                  >
                                    {item.Tag.tag}
                                  </a>
                                </li>
                              )
                            })
                          )}
                        </ul>
                      </li>
                      {authData.isStudyUser && this.props.is_auth && condition.includes('irehab') &&
                        <li className="nav-item">
                          <Link
                            onClick={() => { this.changeHeaderClass(); this.savePageUrl("/account/dashboard/schedule/" + condition) }}
                            className={"pointer nav-link link-scroll font-book navalign " + ((headerUrl.indexOf('/account/dashboard/schedule/') !== -1)
                              ? "active"
                              : "")}
                            to={"/account/dashboard/schedule/" + condition}
                          >
                            My Schedule
                          </Link>
                        </li>
                      }
                      {authData.isStudyUser && this.props.is_auth && condition.includes('irehab') && <li className="nav-item">
                        <Link
                          onClick={() => { this.changeHeaderClass(); this.savePageUrl("/account/dashboard/groups/" + condition) }}
                          className={"pointer nav-link link-scroll font-book navalign " + ((headerUrl.indexOf('/account/dashboard/groups/') !== -1)
                            ? "active"
                            : "")}
                          to={"/account/dashboard/groups/" + condition}
                        >
                          My Groups
                        </Link>
                      </li>
                      }
                    </>
                  }
                  {this.props.is_auth && authData && authData.UserConditions && (this.props.healthcondition_list.length != authData.UserConditions.length) &&
                    <li className="dropdown nav-item text-capitalize" >
                      <a
                        className="dropdown-toggle nav-link link-scroll font-book navalign"
                        role="button"
                        aria-expanded="false"
                        aria-haspopup="true"
                        href="#"
                        data-toggle="dropdown"

                      >
                        Explore conditions{" "}
                        <i className="fa  fa-2x pull-right small-arrow fa-angle-down"></i>
                      </a>
                      <ul className="dropdown-menu">
                        {(this.props.explore_conditions.length &&
                          this.props.explore_conditions.map((item, key) => {
                            return (
                              <li className="nav-item" >
                                <a
                                  className="nav-link link-scroll font-medium navalign pointer"
                                  onClick={() => {
                                    var url = '/on-demand/';

                                    this.changeHeaderClass();
                                    this.getConditionPopup(url, true, item.tag);
                                    this.props.getConditionBanner(item.tag)

                                  }}
                                >
                                  {item.tag}
                                </a>
                              </li>
                            )
                          })
                        )}
                      </ul>
                    </li>
                  }
                  {(!this.props.is_auth &&
                    <li className="dropdown nav-item text-capitalize" >
                      <a
                        className="dropdown-toggle nav-link link-scroll font-book navalign"
                        role="button"
                        aria-expanded="false"
                        aria-haspopup="true"
                        href="#"
                        data-toggle="dropdown"

                      >
                        Conditions{" "}
                        <i className="fa  fa-2x pull-right small-arrow fa-angle-down"></i>
                      </a>
                      <ul className="dropdown-menu">
                        {(this.props.healthcondition_list.length &&
                          this.props.healthcondition_list.map((item, key) => {
                            return (
                              <li className="nav-item" >
                                <a
                                  className="nav-link link-scroll font-medium navalign pointer"
                                  onClick={() => {
                                    var url = '/on-demand/';

                                    this.changeHeaderClass();
                                    this.getConditionPopup(url, true, item.tag)
                                    this.props.getConditionBanner(item.tag)

                                  }}
                                >
                                  {item.tag}
                                </a>
                              </li>
                            )
                          })
                        )}
                      </ul>
                    </li>
                  )
                  }
                  {/* (!this.props.is_auth || (this.props.is_auth && authData && ((!authData.isStudyUser && !authData.isStudyLeader && !authData.isGroupLeader && !authData.isStudyInstructor && commonService.replaceChar(menuCondition, true).toLowerCase() != constand.ASTHMA_CONDITION)))) &&
                    <li className="dropdown nav-item" >
                      <a
                        className="dropdown-toggle nav-link link-scroll font-book navalign"
                        role="button"
                        aria-expanded="false"
                        aria-haspopup="true"
                        href="#"
                        data-toggle="dropdown"
                        ref={'ondemandRef'}

                      >
                        On-Demand{" "}
                        <i className="fa  fa-2x pull-right small-arrow fa-angle-down"></i>
                      </a>
                      <ul className="dropdown-menu">

                        <li className="nav-item" >
                          <Link
                            className="nav-link link-scroll font-book navalign"
                            onClick={() => { this.changeHeaderClass(); this.getConditionPopup('/on-demand/') }}
                          >
                            <p className="purplefont capitalize_text">
                              On-demand classes
                            </p>
                          </Link>
                        </li>
                        {(!this.props.is_auth || (this.props.is_auth && authData && ((!authData.isStudyLeader && !authData.isGroupLeader && !authData.isStudyInstructor) || ((authData.isStudyLeader || authData.isGroupLeader || authData.isStudyInstructor) && constand.SL_MENU.includes('programs'))))) &&
                          <li className="nav-item" >
                            <Link
                              className="nav-link link-scroll font-book navalign"
                              onClick={() => { this.getConditionPopup('/programmes/') }}
                            >
                              <p className="purplefont capitalize_text">
                                Programmes
                              </p>
                            </Link>

                          </li>
                        }

                      </ul>
                    </li>
                  */ }
                  {(!this.props.is_auth || (this.props.is_auth && !authData.isStudyUser && (((authData.isGroupLeader || authData.isStudyLeader || authData.isStudyInstructor) && constand.SL_MENU.includes('on-demand')) || (constand.CORE_MENU.includes('on-demand'))))) &&
                    <li className="nav-item">
                      <Link
                        onClick={() => { this.changeHeaderClass(); this.getConditionPopup('/on-demand/') }}
                        className="nav-link link-scroll font-book navalign"
                      > On-demand Classes
                      </Link>
                    </li>}
                  {(!this.props.is_auth || (this.props.is_auth && !authData.isStudyUser && (((authData.isGroupLeader || authData.isStudyLeader || authData.isStudyInstructor) && constand.SL_MENU.includes('programs')) || (constand.CORE_MENU.includes('programs') && this.props.is_menu_has_data)))) &&
                    <li className="nav-item">
                      <Link
                        onClick={() => { this.changeHeaderClass(); this.getConditionPopup('/programmes/') }}
                        className="nav-link link-scroll font-book navalign"
                      > Programmes
                      </Link>
                    </li>}
                  {((!this.props.is_auth && commonService.replaceChar(menuCondition, true).toLowerCase() != constand.CANCER_CONDITION && commonService.replaceChar(menuCondition, true).toLowerCase() != constand.POSTNATAL_CONDITION && commonService.replaceChar(menuCondition, true).toLowerCase() != constand.MENO_CONDITION && commonService.replaceChar(menuCondition, true).toLowerCase() != constand.KD_YOUTH) || (this.props.is_auth && !authData.isStudyUser && ((!authData.isStudyLeader && !authData.isGroupLeader && !authData.isStudyInstructor && commonService.replaceChar(menuCondition, true).toLowerCase() != constand.CANCER_CONDITION && commonService.replaceChar(menuCondition, true).toLowerCase() != constand.POSTNATAL_CONDITION && commonService.replaceChar(menuCondition, true).toLowerCase() != constand.MENO_CONDITION && commonService.replaceChar(menuCondition, true).toLowerCase() != constand.KD_YOUTH) || ((authData.isGroupLeader || authData.isStudyLeader || authData.isStudyInstructor) && constand.SL_MENU.includes('liveClasses'))))) &&
                    <li className="nav-item">
                      <Link
                        onClick={() => { this.changeHeaderClass(); this.getConditionPopup('/liveClasses/') }}
                        className="nav-link link-scroll font-book navalign"

                      >
                        Live Classes
                      </Link>
                    </li>}
                  {((!this.props.is_auth && commonService.replaceChar(menuCondition, true).toLowerCase() != constand.POSTNATAL_CONDITION && commonService.replaceChar(menuCondition, true).toLowerCase() != constand.MENO_CONDITION) || (this.props.is_auth && !authData.isStudyUser && ((!authData.isStudyLeader && !authData.isGroupLeader && !authData.isStudyInstructor && commonService.replaceChar(menuCondition, true).toLowerCase() != constand.POSTNATAL_CONDITION && commonService.replaceChar(menuCondition, true).toLowerCase() != constand.MENO_CONDITION) || ((authData.isGroupLeader || authData.isStudyLeader || authData.isStudyInstructor) && constand.SL_MENU.includes('groups'))))) &&
                    <li className="nav-item">
                      <Link
                        onClick={() => { this.changeHeaderClass(); this.getConditionPopup('/groups/') }}
                        className="nav-link link-scroll font-book navalign"
                      >
                        Groups
                      </Link>
                    </li>
                  }
                  {(!this.props.is_auth || (this.props.is_auth && !authData.isStudyUser && ((!authData.isStudyLeader && !authData.isGroupLeader && !authData.isStudyInstructor && constand.CORE_MENU.includes('instructor')) || ((authData.isGroupLeader || authData.isStudyLeader || authData.isStudyInstructor) && constand.SL_MENU.includes('instructor'))))) &&
                    <li className="nav-item">
                      <Link
                        onClick={() => { this.changeHeaderClass(); this.getConditionPopup('/instructor/') }}
                        className="nav-link link-scroll font-book navalign"
                      >
                        Instructors
                      </Link>
                    </li>
                  }
                  {(!this.props.is_auth || (this.props.is_auth && !authData.isStudyUser && ((!authData.isStudyLeader && !authData.isGroupLeader && !authData.isStudyInstructor) || ((authData.isGroupLeader || authData.isStudyLeader || authData.isStudyInstructor) && constand.SL_MENU.includes('resources'))))) &&
                    // <li className="nav-item">
                    //   <a
                    //     onClick={() => { this.changeHeaderClass(); this.getConditionPopup('/resources/') }}
                    //     className="nav-link link-scroll font-book navalign"

                    //   >
                    //     Resources
                    //   </a>
                    // </li>
                    <li className={this.state.resourceAriaExpand ? "dropdown nav-item show" : "dropdown nav-item"} onClick={this.handleClickRef.bind(this, 'resourceRef')}>
                      <a
                        className="dropdown-toggle nav-link link-scroll font-book navalign"
                        ref={'resourceRef'}
                        onClick={() => { this.getConditionPopup('/resources/') }}
                      >
                        Resources{" "}
                        <i className="fa  fa-2x pull-right small-arrow fa-angle-down"></i>
                      </a>
                      <ul className={this.state.resourceAriaExpand ? "dropdown-menu show" : "dropdown-menu"}>
                        <li className="nav-item" >
                          <Link
                            onClick={() => { this.changeHeaderClass(); }}
                            className="pointer nav-link link-scroll font-medium navalign"
                            to={"/faq"}
                          >
                            <p className="purplefont capitalize_text m-0">
                              FAQ
                            </p>
                          </Link>
                        </li>
                        {this.state.blogCategories.length > 0 && (
                                <li className="nav-item" key={this.state.blogCategories[1].tagname}>
                                  <Link
                                    onClick={() => { this.changeHeaderClass(); }}
                                    className="pointer nav-link link-scroll font-medium navalign"
                                    to={"/resources/" + this.state.blogCategories[1].tagname}
                                  >
                                    <p className="purplefont capitalize_text m-0">
                                      {this.state.blogCategories[1].value}
                                    </p>
                                  </Link>
                                </li>
                        )}
                        <li className="nav-item" >
                          <Link
                            onClick={() => { this.props.loadReciteMeService() }}
                            className="pointer nav-link link-scroll font-medium navalign"
                          >
                            <p className="purplefont capitalize_text m-0">
                              Accessibility toolbar
                            </p>
                          </Link>
                        </li>
                        {this.state.blogCategories.length > 0 && (
                                <li className="nav-item" key={this.state.blogCategories[0].tagname}>
                                  <Link
                                    onClick={() => { this.changeHeaderClass(); }}
                                    className="pointer nav-link link-scroll font-medium navalign"
                                    to={"/resources/" + this.state.blogCategories[0].tagname}
                                  >
                                    <p className="purplefont capitalize_text m-0">
                                      {this.state.blogCategories[0].value}
                                    </p>
                                  </Link>
                                </li>
                        )}
                        {this.state.blogCategories.length > 0 && (
                                <li className="nav-item" key={this.state.blogCategories[2].tagname}>
                                  <Link
                                    onClick={() => { this.changeHeaderClass(); }}
                                    className="pointer nav-link link-scroll font-medium navalign"
                                    to={"/resources/" + this.state.blogCategories[2].tagname}
                                  >
                                    <p className="purplefont capitalize_text m-0">
                                      {this.state.blogCategories[2].value}
                                    </p>
                                  </Link>
                                </li>
                        )}
                        <li className="nav-item" >
                          <Link
                            onClick={() => { this.changeHeaderClass(); this.getConditionPopup('/resources/all/') }}
                            className="pointer nav-link link-scroll font-medium navalign"
                          >
                            <p className="purplefont capitalize_text m-0">
                              All Resources
                            </p>
                          </Link>
                        </li>

                      </ul>

                    </li>
                  }
                  {(!this.props.is_auth || (this.props.is_auth && !authData.isStudyUser && ((!authData.isStudyLeader && !authData.isGroupLeader && !authData.isStudyInstructor) || ((authData.isGroupLeader || authData.isStudyLeader || !authData.isStudyInstructor) && constand.SL_MENU.includes('howitworks'))))) &&
                    <li className={this.state.aboutAriaExpand ? "dropdown nav-item show" : "dropdown nav-item"} onClick={this.handleClickRef.bind(this, 'aboutRef')} >
                      <a
                        className="dropdown-toggle nav-link link-scroll font-book navalign"
                        ref={'aboutRef'}
                      >
                        About{" "}
                        <i className="fa  fa-2x pull-right small-arrow fa-angle-down"></i>
                      </a>
                      <ul className={this.state.aboutAriaExpand ? "dropdown-menu show" : "dropdown-menu"} >
                        <li className="nav-item" >
                          <Link
                            onClick={() => this.changeHeaderClass("/howitworks")}
                            className="nav-link link-scroll font-book navalign"
                            to={"/howitworks"}
                          >
                            <p className="purplefont capitalize_text">
                              How it works
                            </p>
                          </Link>

                        </li>
                        <li className="nav-item" >
                          <Link
                            onClick={() => this.savePageUrl("/about-us")}
                            className="pointer nav-link link-scroll font-medium navalign"
                            to={"/about-us"}
                          >
                            <p className="purplefont capitalize_text m-0">
                              About us
                            </p>
                          </Link>
                        </li>
                        <li className="nav-item" >
                          <Link
                            className="pointer nav-link link-scroll font-medium navalign"
                            to={"/blogs/kidney-beam-am-i-eligible"}
                          >
                            <p className="purplefont capitalize_text m-0">
                              Am I eligible?
                            </p>
                          </Link>
                        </li>

                        {commonService.replaceChar(menuCondition, true).toLowerCase() == constand.CONDITION_LIST[0] &&
                          <li className="nav-item" >
                            <a
                              onClick={() => { this.changeHeaderClass(); this.getConditionPopup('/about/') }}
                              className="nav-link link-scroll font-book navalign"
                            >
                              <p className="purplefont capitalize_text text_wrap">

                                About exercise for cystic fibrosis
                              </p>
                            </a>
                          </li>
                        }


                        <li className="nav-item" tabIndex="-1">
                          <Link
                            onClick={() => this.changeHeaderClass("/contact-us")}
                            className="nav-link link-scroll font-book navalign"
                            to={"/contact-us"}
                          >
                            <p className="purplefont capitalize_text">
                              Contact
                            </p>
                          </Link>
                        </li>
                        {/* <li className="nav-item" tabIndex="-1">
                          <Link
                            onClick={() => this.changeHeaderClass("/faq")}
                            className="nav-link link-scroll font-book navalign"
                            to={"/faq"}
                          >
                            <p className="purplefont capitalize_text">
                              FAQ
                            </p>
                          </Link>
                        </li> */}
                      </ul>
                    </li>
                  }
                  {/* {(!this.props.is_auth || (this.props.is_auth && !authData.isStudyUser && ((!authData.isStudyLeader && !authData.isGroupLeader && !authData.isStudyInstructor) || ((authData.isStudyLeader || authData.isGroupLeader || authData.isStudyInstructor) && constand.SL_MENU.includes('partnerships'))))) && menuCondition != constand.POSTNATAL_CONDITION && menuCondition != constand.MENO_CONDITION && commonService.replaceChar(menuCondition, true).toLowerCase() != constand.ASTHMA_CONDITION && commonService.replaceChar(menuCondition, true).toLowerCase() != constand.KD_YOUTH && <li className="nav-item">
                    <a
                      onClick={() => { this.changeHeaderClass(); this.getConditionPopup('/partnerships/') }}
                      className="nav-link link-scroll font-book navalign"

                    >
                      For clinicians
                    </a>
                  </li>
                  } */}
                  {this.props.is_auth && authData.isTeensOnBeam && this.props.teens_on_beam_details && this.props.teens_on_beam_details.length
                    > 0 && constand.CMS_PAGES.includes('teensonbeam') && <li className="nav-item">
                      <Link
                        onClick={() => { this.changeHeaderClass(); this.savePageUrl("/teens-on-beam") }}
                        className={"pointer nav-link link-scroll font-book navalign " + ((headerUrl.indexOf('/teens-on-beam') !== -1)
                          ? "active"
                          : "")}
                        to={"/teens-on-beam"}
                      >
                        Teens on Beam
                      </Link>
                    </li>
                  }
                  {!this.props.is_auth && (
                    <li className="nav-item trail-btn-show">
                      <Link
                        onClick={this.changeHeaderClass}
                        className="nav-link navalign font-book  pointer"
                        to="/register"
                      >
                        Start trial
                      </Link>
                    </li>
                  )}
                  {this.props.is_auth && (
                    <li className={this.state.notifyAriaExpand ? "dropdown nav-item show" : "dropdown nav-item"} onClick={this.handleClickRef.bind(this, 'notificationRef')} >
                      <a
                        className="dropdown-toggle nav-link link-scroll font-book navalign"
                        /* role="button"
                        aria-expanded="false"
                        aria-haspopup="true"
                        href="#"
                        data-toggle="dropdown" */
                        ref={'notificationRef'}
                      >
                        Notifications{" "}
                        <span class="label label-primary">{this.props.notification.length}</span>
                        {(this.props.notification.length > 0) &&
                          <i className="fa  fa-2x pull-right small-arrow fa-angle-down"></i>}
                      </a>
                      {(this.props.notification.length > 0) && this._renderMobileNotification()}
                    </li>
                  )}
                  {this.props.is_auth && (
                    <li className={this.state.accountAriaExpand ? "dropdown nav-item show" : "dropdown nav-item"} onClick={this.handleClickRef.bind(this, 'accountRef')}  >
                      <a
                        className="dropdown-toggle nav-link link-scroll font-book navalign"
                      >
                        My Kidney beam{" "}
                        <i className="fa  fa-2x pull-right small-arrow fa-angle-down"></i>
                      </a>
                      <ul className={this.state.accountAriaExpand ? "dropdown-menu show" : "dropdown-menu"} ref={'accountRef'} >
                        <li className="nav-item">
                          <Link
                            onClick={() => { this.changeHeaderClass(); this.getConditionPopup('/account/dashboard/schedule/') }}
                            className={
                              (matchPath(
                                this.props.location.pathname,
                                "/account/dashboard/"
                              )
                                ? "orangefont "
                                : "") +
                              "nav-link link-scroll font-book navalign"
                            }
                          >
                            <div className="purplefont">Dashboard</div>
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            onClick={() => this.changeHeaderClass("/accounts/basicInformation")}
                            className={
                              (matchPath(
                                this.props.location.pathname,
                                "/accounts/basicInformation"
                              )
                                ? "orangefont "
                                : "") +
                              "nav-link link-scroll font-book navalign"
                            }
                            to="/accounts/basicInformation"
                          >
                            <div className="purplefont">Account Details</div>
                          </Link>
                        </li>
                        {masterUserDetails && masterUserDetails.childUser && masterUserDetails.childUser.length > 0 && !condition.includes('research') &&
                          <li className="nav-item">
                            <Link
                              onClick={() => { this.props.switchAccount(true) }}
                              className="nav-link link-scroll font-book navalign"
                            >
                              <div className="purplefont">Switch Accounts</div>
                            </Link>
                          </li>
                        }
                        <li className="nav-item">
                          <Link
                            onClick={() => { this.changeHeaderClass(); this.logoutClick() }}
                            className="nav-link link-scroll font-book navalign"
                          >
                            <div className="purplefont">Logout</div>
                          </Link>
                        </li>
                      </ul>
                    </li>
                  )}
                </ul>
              </div>
              {/* start web view */}
              <div className="collapse navbar-collapse float-right" id="navbarNavAltMarkup">
                {this.props.is_auth && authData && (
                  <React.Fragment>
                    {!authData.isStudyUser &&
                       <ul className="navbar-nav ml-auto align-items-start  align-items-lg-center">
                        {/* {((!authData.isStudyLeader && !authData.isGroupLeader && !authData.isStudyInstructor && commonService.replaceChar(menuCondition, true).toLowerCase() != constand.ASTHMA_CONDITION)) &&
                          <li className="dropdown nav-item">
                            <a
                              className={"dropdown-toggle nav-link link-scroll font-book navalign " + ((headerUrl.indexOf('/on-demand') !== -1) || (headerUrl.indexOf('/programs') !== -1)
                                ? "active"
                                : "")}
                              role="button"
                              aria-expanded="false"
                              aria-haspopup="true"
                              href="#"
                              data-toggle="dropdown"
                            >
                              On-Demand<span className="arrow-std caret"></span>{" "}
                              <i
                                className={
                                  "fa  fa-2x pull-right small-arrow " +
                                  (this.state.is_menu_open === true
                                    ? "fa-angle-down"
                                    : "fa-angle-up")
                                }
                                onClick={this.changeDrowndownArrow}
                              ></i>
                            </a>
                            <ul className="dropdown-menu">

                              <li className="nav-item" >
                                <Link
                                  className="nav-link link-scroll font-medium navalign"
                                  onClick={() => { this.getConditionPopup('/on-demand/') }}
                                >
                                  <p className="purplefont capitalize_text m-0">
                                    On-demand classes
                                  </p>
                                </Link>

                              </li>

                              {((!authData.isStudyLeader && !authData.isGroupLeader && !authData.isStudyInstructor) || ((authData.isGroupLeader || authData.isStudyLeader || authData.isStudyInstructor) && constand.SL_MENU.includes('programs'))) &&
                                <li className="nav-item" >
                                  <Link
                                    className="nav-link link-scroll font-medium navalign"
                                    onClick={() => { this.getConditionPopup('/programmes/') }}
                                  >
                                    <p className="purplefont capitalize_text m-0">
                                      Programmes
                                    </p>
                                  </Link>

                                </li>
                              }
                            </ul>
                          </li>
                        } */}

                        {(((authData.isGroupLeader || authData.isStudyLeader || authData.isStudyInstructor) && constand.SL_MENU.includes('on-demand')) || (!authData.isStudyLeader && !authData.isGroupLeader && !authData.isStudyInstructor)) &&
                          <li className="nav-item">
                            <span
                              className={"pointer nav-link link-scroll font-book navalign " + ((headerUrl.indexOf('/on-demand/') !== -1)
                                ? "active"
                                : "")}
                              onClick={() => { this.getConditionPopup('/on-demand/') }}
                            >
                              On-demand Classes
                            </span>
                          </li>
                        }
                        {(((authData.isGroupLeader || authData.isStudyLeader || authData.isStudyInstructor) && constand.SL_MENU.includes('programs')) || (!authData.isStudyLeader && !authData.isGroupLeader && !authData.isStudyInstructor && constand.CORE_MENU.includes('programs') && this.props.is_menu_has_data)) &&
                          <li className="nav-item">
                            <span
                              className={"pointer nav-link link-scroll font-book navalign " + ((headerUrl.indexOf('/programmes/') !== -1)
                                ? "active"
                                : "")}
                              onClick={() => { this.getConditionPopup('/programmes/') }}
                            >
                              Programmes
                            </span>
                          </li>
                        }
                        {((!authData.isStudyLeader && !authData.isGroupLeader && !authData.isStudyInstructor && commonService.replaceChar(menuCondition, true).toLowerCase() != constand.CANCER_CONDITION && commonService.replaceChar(menuCondition, true).toLowerCase() != constand.POSTNATAL_CONDITION && commonService.replaceChar(menuCondition, true).toLowerCase() != constand.MENO_CONDITION && commonService.replaceChar(menuCondition, true).toLowerCase() != constand.KD_YOUTH) || ((authData.isGroupLeader || authData.isStudyLeader || authData.isStudyInstructor) && constand.SL_MENU.includes('liveClasses'))) &&
                          <li className="nav-item">
                            <span
                              className={"pointer nav-link link-scroll font-book navalign " + ((headerUrl.indexOf('/liveClasses/') !== -1)
                                ? "active"
                                : "")}
                              onClick={() => { this.getConditionPopup('/liveClasses/') }}
                            >
                              Live Classes
                            </span>
                          </li>
                        }

                        {((!authData.isStudyLeader && !authData.isGroupLeader && !authData.isStudyInstructor && commonService.replaceChar(menuCondition, true).toLowerCase() != constand.POSTNATAL_CONDITION && commonService.replaceChar(menuCondition, true).toLowerCase() != constand.MENO_CONDITION) || ((authData.isGroupLeader || authData.isStudyLeader || authData.isStudyInstructor) && constand.SL_MENU.includes('groups'))) &&
                          <li className="nav-item">
                            <span
                              onClick={() => { this.getConditionPopup('/groups/') }}
                              className={"pointer nav-link link-scroll font-book navalign " + ((headerUrl.indexOf('/groups/') !== -1)
                                ? "active"
                                : "")}
                            >
                              Groups
                            </span>
                          </li>
                        }
                        {((!authData.isStudyLeader && !authData.isGroupLeader && !authData.isStudyInstructor && (constand.CORE_MENU.includes('instructor'))) || ((authData.isGroupLeader || authData.isStudyLeader || authData.isStudyInstructor) && constand.SL_MENU.includes('instructor'))) &&
                          <li className="nav-item">
                            <span
                              onClick={() => { this.getConditionPopup('/instructor/') }}
                              className={"pointer nav-link link-scroll font-book navalign " + ((headerUrl.indexOf('/instructor/') !== -1)
                                ? "active"
                                : "")}
                            >
                              Instructors
                            </span>
                          </li>
                        }
                        {((!authData.isStudyLeader && !authData.isGroupLeader && !authData.isStudyInstructor) || ((authData.isGroupLeader || authData.isStudyLeader || authData.isStudyInstructor) && constand.SL_MENU.includes('resources'))) &&
                          // <li className="nav-item">
                          //   <span
                          //     onClick={() => { this.changeHeaderClass(); }}

                          //     className={"pointer nav-link link-scroll font-book navalign " + ((headerUrl.indexOf('/resources/') !== -1)
                          //       ? "active"
                          //       : "")}
                          //   >
                          //     Resources
                          //   </span>
                          // </li>
                          <li className="dropdown nav-item">
                            <a
                              className={"dropdown-toggle nav-link link-scroll font-book navalign " + (headerUrl.indexOf('/resources/') === -1 && (headerUrl.indexOf('/faq') !== -1) ? "active" : "")}
                              role="button"
                              aria-expanded="false"
                              aria-haspopup="true"
                              href="#"
                              data-toggle="dropdown"
                            >
                              Resources<span className="arrow-std caret"></span>{" "}
                              <i
                                className={
                                  "fa  fa-2x pull-right small-arrow " +
                                  (this.state.is_menu_open === true
                                    ? "fa-angle-down"
                                    : "fa-angle-up")
                                }
                                onClick={this.changeDrowndownArrow}
                              ></i>
                            </a>
                            <ul className="dropdown-menu long-length">
                              <li className="nav-item" >
                                <Link
                                  onClick={() => this.savePageUrl("/faq")}
                                  className="pointer nav-link link-scroll font-medium navalign"
                                  to={"/faq"}
                                >
                                  <p className="purplefont capitalize_text m-0">
                                    FAQ
                                  </p>
                                </Link>
                              </li>
                              {this.state.blogCategories.length > 0 && (
                                <li className="nav-item" key={this.state.blogCategories[1].tagname}>
                                  <Link
                                    onClick={() => { this.changeHeaderClass(); }}
                                    className="pointer nav-link link-scroll font-medium navalign"
                                    to={"/resources/" + this.state.blogCategories[1].tagname}
                                  >
                                    <p className="purplefont capitalize_text m-0">
                                      {this.state.blogCategories[1].value}
                                    </p>
                                  </Link>
                                </li>
                              )}
                              <li className="nav-item" >
                                <Link
                                  onClick={() => { this.props.loadReciteMeService() }}
                                  className="pointer nav-link link-scroll font-medium navalign"
                                >
                                  <p className="purplefont capitalize_text m-0">
                                    Accessibility toolbar
                                  </p>
                                </Link>
                              </li>
                              {this.state.blogCategories.length > 0 && (
                                <li className="nav-item" key={this.state.blogCategories[0].tagname}>
                                  <Link
                                    onClick={() => { this.changeHeaderClass(); }}
                                    className="pointer nav-link link-scroll font-medium navalign"
                                    to={"/resources/" + this.state.blogCategories[0].tagname}
                                  >
                                    <p className="purplefont capitalize_text m-0">
                                      {this.state.blogCategories[0].value}
                                    </p>
                                  </Link>
                                </li>
                              )}
                              {this.state.blogCategories.length > 0 && (
                                <li className="nav-item" key={this.state.blogCategories[2].tagname}>
                                  <Link
                                    onClick={() => { this.changeHeaderClass(); }}
                                    className="pointer nav-link link-scroll font-medium navalign"
                                    to={"/resources/" + this.state.blogCategories[2].tagname}
                                  >
                                    <p className="purplefont capitalize_text m-0">
                                      {this.state.blogCategories[2].value}
                                    </p>
                                  </Link>
                                </li>
                              )}
                              <li className="nav-item" >
                                <Link
                                  onClick={() => { this.changeHeaderClass(); this.getConditionPopup('/resources/all/') }}
                                  className="pointer nav-link link-scroll font-medium navalign"
                                // to={"/resources/all"}
                                >
                                  <p className="purplefont capitalize_text m-0">
                                    All Resources
                                  </p>
                                </Link>
                              </li>
                            </ul>
                          </li>
                        }
                        {((!authData.isStudyLeader && !authData.isGroupLeader && !authData.isStudyInstructor) || ((authData.isGroupLeader || authData.isStudyLeader || authData.isStudyInstructor) && constand.SL_MENU.includes('howitworks'))) &&
                          <li className="dropdown nav-item">
                            <a
                              className={"dropdown-toggle nav-link link-scroll font-book navalign " + ((headerUrl.indexOf('/howitworks') !== -1) || (headerUrl.indexOf('/about-us') !== -1) || (headerUrl.indexOf('/about/') !== -1) || (headerUrl.indexOf('/contact-us') !== -1)
                                ? "active"
                                : "")}
                              role="button"
                              aria-expanded="false"
                              aria-haspopup="true"
                              href="#"
                              data-toggle="dropdown"
                            >
                              About<span className="arrow-std caret"></span>{" "}
                              <i
                                className={
                                  "fa  fa-2x pull-right small-arrow " +
                                  (this.state.is_menu_open === true
                                    ? "fa-angle-down"
                                    : "fa-angle-up")
                                }
                                onClick={this.changeDrowndownArrow}
                              ></i>
                            </a>
                            <ul className="dropdown-menu long-length">

                              <li className="nav-item" >
                                <Link
                                  onClick={() => this.savePageUrl("/howitworks")}
                                  className="pointer nav-link link-scroll font-medium navalign"
                                  to={"/howitworks"}
                                >
                                  <p className="purplefont capitalize_text m-0">
                                    How it works
                                  </p>
                                </Link>

                              </li>

                              <li className="nav-item" >
                                <Link
                                  onClick={() => this.savePageUrl("/about-us")}
                                  className="pointer nav-link link-scroll font-medium navalign"
                                  to={"/about-us"}
                                >
                                  <p className="purplefont capitalize_text m-0">
                                    About us
                                  </p>
                                </Link>
                              </li>
                              <li className="nav-item" >
                                <Link
                                  className="pointer nav-link link-scroll font-medium navalign"
                                  to={"/blogs/kidney-beam-am-i-eligible"}
                                >
                                  <p className="purplefont capitalize_text m-0">
                                    Am I eligible?
                                  </p>
                                </Link>
                              </li>
                              {commonService.replaceChar(menuCondition, true).toLowerCase() == constand.CONDITION_LIST[0] &&
                                <li className="nav-item" >
                                  <span
                                    onClick={() => { this.changeHeaderClass(); this.getConditionPopup('/about/') }}
                                    className="pointer nav-link link-scroll font-medium navalign"
                                  >
                                    <p className="purplefont capitalize_text m-0">

                                      About exercise for cystic fibrosis
                                    </p>
                                  </span>
                                </li>
                              }

                              <li className="nav-item" >
                                <Link
                                  onClick={() => this.savePageUrl("/contact-us")}
                                  className="pointer nav-link link-scroll font-medium navalign"
                                  to={"/contact-us"}
                                >
                                  <p className="purplefont capitalize_text m-0">
                                    Contact
                                  </p>
                                </Link>
                              </li>
                              {/* <li className="nav-item" >
                                <Link
                                  onClick={() => this.savePageUrl("/faq")}
                                  className="pointer nav-link link-scroll font-medium navalign"
                                  to={"/faq"}
                                >
                                  <p className="purplefont capitalize_text m-0">
                                    FAQ
                                  </p>
                                </Link>
                              </li> */}
                            </ul>
                          </li>
                        }
                        {/* {menuCondition != constand.POSTNATAL_CONDITION && commonService.replaceChar(menuCondition, true).toLowerCase() != constand.ASTHMA_CONDITION && menuCondition != constand.MENO_CONDITION && ((!authData.isStudyLeader && !authData.isGroupLeader && !authData.isStudyInstructor) || ((authData.isGroupLeader || authData.isStudyLeader || authData.isStudyInstructor) && constand.SL_MENU.includes('partnerships'))) && commonService.replaceChar(menuCondition, true).toLowerCase() != constand.KD_YOUTH && <li className="nav-item">
                          <span
                            onClick={() => { this.changeHeaderClass(); this.getConditionPopup('/partnerships/') }}
                            className={"pointer nav-link link-scroll font-book navalign " + ((headerUrl.indexOf('/partnerships/') !== -1)
                              ? "active"
                              : "")}
                          >
                            For clinicians
                          </span>
                        </li>
                        } */}
                        {this.props.is_auth && authData.isTeensOnBeam && this.props.teens_on_beam_details && this.props.teens_on_beam_details.length
                          > 0 && constand.CMS_PAGES.includes('teensonbeam') && <li className="nav-item">
                            <Link
                              onClick={() => { this.changeHeaderClass(); this.savePageUrl("/teens-on-beam") }}
                              className={"pointer nav-link link-scroll font-book navalign " + ((headerUrl.indexOf('/teens-on-beam') !== -1)
                                ? "active"
                                : "")}
                              to={"/teens-on-beam"}
                            >
                              Teens on Kidney Beam
                            </Link>
                          </li>
                        }
                        {<li className="bell-sub dropdown nav-item">
                          <a
                            className="dropdown-toggle icon-info  nav-link link-scroll font-book navalign"
                            role="button"
                            aria-expanded="false"
                            aria-haspopup="true"
                            href="#"
                            data-toggle="dropdown"
                          >
                            <i
                              className={(this.state.active_bell) ? "bell fa fa-bell-o black-txt medium-text" : "fa fa-bell-o black-txt medium-text"}
                              aria-hidden="true"
                            ></i>
                            <span className="label label-primary">{this.props.notification.length}</span>
                            {(this.props.notification.length > 0) && <React.Fragment>
                              <span className="arrow-std caret nocaret"></span>{" "}
                              <i className="fa  fa-2x pull-right small-arrow fa-angle-up"></i></React.Fragment>}
                          </a>
                          {(this.props.notification.length > 0) &&
                            <ul className="dropdown-menu">
                              {this._renderNotification()}
                            </ul>}
                        </li>}
                        {this.props.is_auth && !this.props.is_create_mode && (((authData.isCreator || (authData.isStudyLeader && authData.SLCondition.indexOf(commonService.replaceChar(menuCondition, true)) != -1)) && constand.CMS_PAGES.includes(this.state.currentPageName))) &&
                          <li>
                            <i class="fa fa-pencil fa-2x orangefont p-r-15 pointer" aria-hidden="true" onClick={() => this.props.changeCMSMode(true)}></i>
                          </li>
                        }
                        {this.props.is_auth && this.props.is_create_mode && (((authData.isCreator || (authData.isStudyLeader && authData.SLCondition.indexOf(commonService.replaceChar(menuCondition, true)) != -1)) && constand.CMS_PAGES.includes(this.state.currentPageName))) &&
                          <li>
                            <i class="fa fa-eye fa-2x orangefont p-r-15 pointer" aria-hidden="true" onClick={() => this.props.changeCMSMode(false)}></i>
                          </li>
                        }
                        {(this.props.is_group_admin || this.props.is_group_leader) && constand.GROUP_PAGE.includes(this.state.currentPageName) && (!authData.isCreator && (!authData.isStudyLeader || (authData.isStudyLeader && authData.SLCondition.indexOf(commonService.replaceChar(menuCondition, true)) == -1 && authData.isGroupLeader && authData.GLCondition.indexOf(commonService.replaceChar(menuCondition, true)) != -1))) && !this.props.is_group_mode && this.props.is_auth &&
                          <li>
                            <i class="fa fa-pencil fa-2x orangefont p-r-15 pointer" aria-hidden="true" onClick={() => this.props.changeCMSGroupMode(true)}></i>
                          </li>
                        }
                        {(this.props.is_group_admin || this.props.is_group_leader) && constand.GROUP_PAGE.includes(this.state.currentPageName) && (!authData.isCreator && (!authData.isStudyLeader || (authData.isStudyLeader && authData.SLCondition.indexOf(commonService.replaceChar(menuCondition, true)) == -1 && authData.isGroupLeader && authData.GLCondition.indexOf(commonService.replaceChar(menuCondition, true)) != -1))) && this.props.is_auth && !authData.isCreator && this.props.is_group_mode &&
                          <li>
                            <i class="fa fa-eye fa-2x orangefont p-r-15 pointer" aria-hidden="true" onClick={() => this.props.changeCMSGroupMode(false)}></i>
                          </li>
                        }
                      </ul>
                    }
                    <ul className={" navbar-nav  profile-img-sec align-items-lg-center "}>
                      {authData.isStudyUser && this.props.is_auth && condition.includes('irehab') && <li className="nav-item">
                        {/*
                        //my schedule full screen page
                        <span
                          onClick={() => { this.getConditionPopup('/my-schedule/') }}
                          className={"pointer nav-link link-scroll font-book navalign " + ((headerUrl.indexOf('/my-schedule/') !== -1)
                            ? "active"
                            : (headerUrl.indexOf('/schedule/') !== -1) ? "active" : '')}
                        >
                          My Schedule
                        </span> */}
                        <Link
                          onClick={() => { this.changeHeaderClass(); this.savePageUrl("/account/dashboard/schedule/" + condition) }}
                          className={"pointer nav-link link-scroll font-book navalign " + ((headerUrl.indexOf('/account/dashboard/schedule/') !== -1)
                            ? "active"
                            : "")}
                          to={"/account/dashboard/schedule/" + condition}
                        >
                          My Schedule
                        </Link>
                      </li>
                      }
                      {authData.isStudyUser && this.props.is_auth && condition.includes('irehab') && <li className="nav-item">
                        {/* <span
                        //my group full screen page
                          onClick={() => { this.getConditionPopup('/my-groups/') }}
                          className={"pointer nav-link link-scroll font-book navalign " + ((headerUrl.indexOf('/my-groups/') !== -1)
                            ? "active"
                            : (headerUrl.indexOf('/groups/') !== -1) ? "active" : '')}
                        >
                          My Groups
                        </span> */}
                        <Link
                          onClick={() => { this.changeHeaderClass(); this.savePageUrl("/account/dashboard/groups/" + condition) }}
                          className={"pointer nav-link link-scroll font-book navalign " + ((headerUrl.indexOf('/account/dashboard/groups/') !== -1)
                            ? "active"
                            : "")}
                          to={"/account/dashboard/groups/" + condition}
                        >
                          My Groups
                        </Link>
                      </li>
                      }
                      <li className="dropdown nav-item profile">
                        <Link className="pointer btn navbar-btn btn-shadow font-medium font-14 btn-gradient button-style" to={"/account/dashboard/schedule/" + commonService.replaceChar(menuCondition, false)} >My Kidney Beam
                        </Link>
                      </li>
                      <li className="dropdown nav-item profile">
                        <a
                          href="#"
                          data-toggle="dropdown"
                          className="toggle  nav-link "
                          role="button"
                          aria-expanded="false"
                          aria-haspopup="true"
                        >
                          <img
                            src={
                              this.props.logged_userData.profilePic
                                ? constand.S3_API_IMG + '/profile/' + this.props.logged_userData.profilePic
                                : constand.WEB_IMAGES + "no-profile-pic.png"
                            }
                            className="rounded-circle img-fluid"
                          />
                          <span className="arrow-std caret nocaret"></span>{" "}
                          <i
                            className={
                              "fa  fa-2x pull-right small-arrow " +
                              (this.state.is_menu_open === true
                                ? "fa-angle-down"
                                : "fa-angle-up")
                            }
                            onClick={this.changeDrowndownArrow}
                          ></i>
                        </a>
                        <ul className="dropdown-menu">
                          <li className="nav-item">
                            <Link
                              //onClick={() => { this.getConditionPopup('/account/dashboard/schedule/') }}
                              to={"/account/dashboard/schedule/" + commonService.replaceChar(menuCondition, false)}
                              className={
                                (matchPath(
                                  this.props.location.pathname,
                                  "/account/dashboard/"
                                )
                                  ? "orangefont "
                                  : "") +
                                "nav-link link-scroll font-book navalign"
                              }
                            >
                              <div className="purplefont">My Kidney Beam</div>
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              className={
                                (matchPath(
                                  this.props.location.pathname,
                                  "/accounts/basicInformation"
                                )
                                  ? "orangefont "
                                  : "") +
                                "nav-link link-scroll font-book navalign"
                              }
                              to="/accounts/basicInformation"
                            >
                              <div className="purplefont">Account Details</div>
                            </Link>
                          </li>
                          {masterUserDetails && masterUserDetails.childUser && masterUserDetails.childUser.length > 0 && !condition.includes('research') &&
                            <li className="nav-item">
                              <span
                                className="nav-link link-scroll switch-account-menu font-book navalign"
                                onClick={() => this.props.switchAccount(true)}
                              >
                                <div className="purplefont">Switch Accounts</div>
                              </span>
                            </li>
                          }
                          <li className="nav-item">
                            <Link
                              className="nav-link link-scroll font-book navalign"
                              to=""
                              onClick={this.logoutClick}
                            >
                              <div className="purplefont">Logout</div>
                            </Link>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </React.Fragment>
                )}
                {!this.props.is_auth && (
                  <ul className="navbar-nav ml-auto align-items-start align-items-lg-center">
                    {/* commonService.replaceChar(menuCondition, true).toLowerCase() != constand.CANCER_CONDITION && commonService.replaceChar(menuCondition, true).toLowerCase() != constand.ASTHMA_CONDITION &&
                      <li className="dropdown nav-item">
                        <a
                          className={"dropdown-toggle nav-link link-scroll font-book navalign " + ((headerUrl.indexOf('/list') !== -1) || (headerUrl.indexOf('/programs') !== -1)
                            ? "active"
                            : "")}
                          role="button"
                          aria-expanded="false"
                          aria-haspopup="true"
                          href="#"
                          data-toggle="dropdown"
                        >
                          On-Demand<span className="arrow-std caret"></span>{" "}
                          <i
                            className={
                              "fa  fa-2x pull-right small-arrow " +
                              (this.state.is_menu_open === true
                                ? "fa-angle-down"
                                : "fa-angle-up")
                            }
                            onClick={this.changeDrowndownArrow}
                          ></i>
                        </a>
                        <ul className="dropdown-menu">

                          <li className="nav-item" >
                            <Link
                              className="nav-link link-scroll font-medium navalign"
                              onClick={() => { this.getConditionPopup('/on-demand/') }}
                            >
                              <p className="purplefont capitalize_text m-0">
                                On-demand classes
                              </p>
                            </Link>
                          </li>

                          <li className="nav-item" >
                            <Link
                              className="nav-link link-scroll font-medium navalign"
                              onClick={() => { this.getConditionPopup('/programmes/') }}
                            >
                              <p className="purplefont capitalize_text m-0">
                                Programmes
                              </p>
                            </Link>

                          </li>
                        </ul>
                      </li>
                     */}
                    {/* (commonService.replaceChar(menuCondition, true).toLowerCase() == constand.CANCER_CONDITION || commonService.replaceChar(menuCondition, true).toLowerCase() == constand.ASTHMA_CONDITION) && */
                      <li className="nav-item">
                        <span
                          className={"pointer nav-link link-scroll font-book navalign " + ((headerUrl.indexOf('/on-demand/') !== -1)
                            ? "active"
                            : "")}
                          onClick={() => { this.getConditionPopup('/on-demand/') }}
                        >
                          On-demand Classes
                        </span>
                      </li>
                    }
                    {constand.CORE_MENU.includes('programs') && this.props.is_menu_has_data &&
                      <li className="nav-item">
                        <span
                          className={"pointer nav-link link-scroll font-book navalign " + ((headerUrl.indexOf('/programmes/') !== -1)
                            ? "active"
                            : "")}
                          onClick={() => { this.getConditionPopup('/programmes/') }}
                        >
                          Programmes
                        </span>
                      </li>
                    }
                    {(commonService.replaceChar(menuCondition, true).toLowerCase() != constand.CANCER_CONDITION && commonService.replaceChar(menuCondition, true).toLowerCase() != constand.POSTNATAL_CONDITION && commonService.replaceChar(menuCondition, true).toLowerCase() != constand.MENO_CONDITION && commonService.replaceChar(menuCondition, true).toLowerCase() != constand.KD_YOUTH) &&
                      <li className="nav-item">
                        <span
                          onClick={() => { this.changeHeaderClass(); this.getConditionPopup('/liveClasses/') }}

                          className={"pointer nav-link link-scroll font-book navalign " + ((headerUrl.indexOf('/liveClasses') !== -1)
                            ? "active"
                            : "")}
                        >
                          Live Classes
                        </span>
                      </li>
                    }
                    {commonService.replaceChar(menuCondition, true).toLowerCase() != constand.POSTNATAL_CONDITION && commonService.replaceChar(menuCondition, true).toLowerCase() != constand.MENO_CONDITION &&
                      <li className="nav-item">
                        <span
                          onClick={() => { this.changeHeaderClass(); this.getConditionPopup('/groups/') }}
                          className={"pointer nav-link link-scroll font-book navalign " + ((headerUrl.indexOf('/groups') !== -1)
                            ? "active"
                            : "")}
                        >
                          Groups
                        </span>
                      </li>
                    }
                    {constand.CORE_MENU.includes('instructor') &&
                      <li className="nav-item">
                        <span
                          onClick={() => { this.changeHeaderClass(); this.getConditionPopup('/instructor/') }}
                          className={"pointer nav-link link-scroll font-book navalign " + ((headerUrl.indexOf('/instructor/') !== -1)
                            ? "active"
                            : "")}
                        >
                          Instructors
                        </span>
                      </li>
                    }
                    {/* <li className="nav-item">
                      <span
                        onClick={() => { this.changeHeaderClass(); this.getConditionPopup('/resources/') }}
                        className={"pointer nav-link link-scroll font-book navalign " + ((headerUrl.indexOf('/resources/') !== -1)
                          ? "active"
                          : "")}
                      >
                        Resources
                      </span>
                    </li> */}
                    <li className="dropdown nav-item">
                      <a
                        className={"dropdown-toggle nav-link link-scroll font-book navalign " + (headerUrl.indexOf('/resources/') !== -1 || (headerUrl.indexOf('/faq') !== -1) ? "active" : "")}
                        role="button"
                        aria-expanded="false"
                        aria-haspopup="true"
                        href="#"
                        data-toggle="dropdown"
                      >
                        Resources<span className="arrow-std caret"></span>{" "}
                        <i
                          className={
                            "fa  fa-2x pull-right small-arrow " +
                            (this.state.is_menu_open === true
                              ? "fa-angle-down"
                              : "fa-angle-up")
                          }
                          onClick={this.changeDrowndownArrow}
                        ></i>
                      </a>
                      <ul className="dropdown-menu long-length">
                        <li className="nav-item" >
                          <Link
                            onClick={() => this.savePageUrl("/faq")}
                            className="pointer nav-link link-scroll font-medium navalign"
                            to={"/faq"}
                          >
                            <p className="purplefont capitalize_text m-0">
                              FAQ
                            </p>
                          </Link>
                        </li>
                        {this.state.blogCategories.length > 0 && (
                                <li className="nav-item" key={this.state.blogCategories[1].tagname}>
                                  <Link
                                    onClick={() => { this.changeHeaderClass(); }}
                                    className="pointer nav-link link-scroll font-medium navalign"
                                    to={"/resources/" + this.state.blogCategories[1].tagname}
                                  >
                                    <p className="purplefont capitalize_text m-0">
                                      {this.state.blogCategories[1].value}
                                    </p>
                                  </Link>
                                </li>
                        )}
                        <li className="nav-item" onClick={() => { this.props.loadReciteMeService() }}  >
                          <Link
                            className="pointer nav-link link-scroll font-medium navalign"

                          >
                            <p className="purplefont capitalize_text m-0">
                              Accessibility toolbar
                            </p>
                          </Link>
                        </li>
                        {this.state.blogCategories.length > 0 && (
                                <li className="nav-item" key={this.state.blogCategories[0].tagname}>
                                  <Link
                                    onClick={() => { this.changeHeaderClass(); }}
                                    className="pointer nav-link link-scroll font-medium navalign"
                                    to={"/resources/" + this.state.blogCategories[0].tagname}
                                  >
                                    <p className="purplefont capitalize_text m-0">
                                      {this.state.blogCategories[0].value}
                                    </p>
                                  </Link>
                                </li>
                        )}
                        {this.state.blogCategories.length > 0 && (
                                <li className="nav-item" key={this.state.blogCategories[2].tagname}>
                                  <Link
                                    onClick={() => { this.changeHeaderClass(); }}
                                    className="pointer nav-link link-scroll font-medium navalign"
                                    to={"/resources/" + this.state.blogCategories[2].tagname}
                                  >
                                    <p className="purplefont capitalize_text m-0">
                                      {this.state.blogCategories[2].value}
                                    </p>
                                  </Link>
                                </li>
                        )}
                        <li className="nav-item" >
                          <Link
                            onClick={() => { this.changeHeaderClass(); this.getConditionPopup('/resources/all/') }}
                            className="pointer nav-link link-scroll font-medium navalign"
                          // to={"/resources/all"}
                          >
                            <p className="purplefont capitalize_text m-0">
                              All Resources
                            </p>
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li className="dropdown nav-item">
                      <a
                        className={"dropdown-toggle nav-link link-scroll font-book navalign " + (headerUrl.indexOf('/group/about/') === -1 && ((headerUrl.indexOf('/howitworks') !== -1) || (headerUrl.indexOf('/about-us') !== -1) || (headerUrl.indexOf('/about/') !== -1) || (headerUrl.indexOf('/contact-us') !== -1))
                          ? "active"
                          : "")}
                        role="button"
                        aria-expanded="false"
                        aria-haspopup="true"
                        href="#"
                        data-toggle="dropdown"
                      >
                        About<span className="arrow-std caret"></span>{" "}
                        <i
                          className={
                            "fa  fa-2x pull-right small-arrow " +
                            (this.state.is_menu_open === true
                              ? "fa-angle-down"
                              : "fa-angle-up")
                          }
                          onClick={this.changeDrowndownArrow}
                        ></i>
                      </a>
                      <ul className="dropdown-menu long-length">

                        <li className="nav-item" >
                          <Link
                            onClick={() => this.savePageUrl("/howitworks")}
                            className="pointer nav-link link-scroll font-medium navalign"
                            to={"/howitworks"}
                          >
                            <p className="purplefont capitalize_text m-0">
                              How it works
                            </p>
                          </Link>

                        </li>

                        {/* <li className="nav-item" >
                          <Link
                            onClick={() => this.savePageUrl("/howitworks/#pricing")}
                            className="pointer nav-link link-scroll font-medium navalign"
                            to={"/howitworks/#pricing"}
                          >
                            <p className="purplefont capitalize_text m-0">
                              Pricing
                            </p>
                          </Link>

                        </li> */}

                        <li className="nav-item" >
                          <Link
                            onClick={() => this.savePageUrl("/about-us")}
                            className="pointer nav-link link-scroll font-medium navalign"
                            to={"/about-us"}
                          >
                            <p className="purplefont capitalize_text m-0">
                              About us
                            </p>
                          </Link>
                        </li>
                        <li className="nav-item" >
                          <Link
                            className="pointer nav-link link-scroll font-medium navalign"
                            to={"/blogs/kidney-beam-am-i-eligible"}
                          >
                            <p className="purplefont capitalize_text m-0">
                              Am I eligible?
                            </p>
                          </Link>
                        </li>
                        {commonService.replaceChar(menuCondition, true).toLowerCase() == constand.CONDITION_LIST[0] &&
                          <li className="nav-item" >
                            <Link
                              onClick={() => { this.getConditionPopup('/about/') }}
                              className="pointer nav-link link-scroll font-medium navalign"
                            >
                              <p className="purplefont capitalize_text m-0">

                                About exercise for cystic fibrosis
                              </p>
                            </Link>

                          </li>
                        }

                        <li className="nav-item" >
                          <Link
                            onClick={() => this.savePageUrl("/contact-us")}
                            className="pointer nav-link link-scroll font-medium navalign"
                            to={"/contact-us"}
                          >
                            <p className="purplefont capitalize_text m-0">
                              Contact
                            </p>
                          </Link>
                        </li>
                        {/* <li className="nav-item" >
                          <Link
                            onClick={() => this.savePageUrl("/faq")}
                            className="pointer nav-link link-scroll font-medium navalign"
                            to={"/faq"}
                          >
                            <p className="purplefont capitalize_text m-0">
                              FAQ
                            </p>
                          </Link>
                        </li> */}
                      </ul>
                    </li>
                    {/* {menuCondition != constand.POSTNATAL_CONDITION && menuCondition != constand.MENO_CONDITION && commonService.replaceChar(menuCondition, true).toLowerCase() != constand.ASTHMA_CONDITION && commonService.replaceChar(menuCondition, true).toLowerCase() != constand.KD_YOUTH &&
                      <li className="nav-item">
                        <span
                          onClick={() => { this.changeHeaderClass(); this.getConditionPopup('/partnerships/') }}

                          className={"pointer nav-link link-scroll font-book navalign " + ((headerUrl.indexOf('/partnerships/') !== -1)
                            ? "active"
                            : "")}
                        >
                          For clinicians
                        </span>
                      </li>
                    } */}
                    <li className="nav-item cursor">
                      <span
                        onClick={this.loginClick}
                        className="nav-link navalign font-book  pointer"
                      >
                        Sign In
                      </span>
                    </li>
                    <li className="nav-item trail-btn-show">
                      <span
                        onClick={this.loginClick}
                        className="nav-link navalign font-book  pointer"
                      >
                        Start trial
                      </span>
                    </li>
                  </ul>
                )}
                {!this.props.is_auth && (
                  <div className="navbar-text  trail-btn-hide">
                    <Link
                      to="/register"
                      className="btn navbar-btn btn-shadow font-medium font-14 btn-gradient button-style"
                    >
                      Register
                    </Link>
                  </div>
                )}
              </div>
            </div>

          </nav >
          <div className={this.props.warning_banner_text.length > 0 ? "m-t-0" : "m-t-0"}>

            {cookieCondition && (typeof Cookies.get(closeBannerCookie) == 'undefined' || Cookies.get(closeBannerCookie) == 'false') && (Object.keys(this.props.close_banner).length == 0 || (Object.keys(this.props.close_banner).length > 0 && (!this.props.close_banner[closeBannerCookie] || typeof this.props.close_banner[closeBannerCookie] == 'undefined'))) && <CffBanner type="web" condition={cookieCondition} />}
            {cookieCondition && (typeof Cookies.get(closeBannerCookie) == 'undefined' || Cookies.get(closeBannerCookie) == 'false') && (Object.keys(this.props.close_banner).length == 0 || (Object.keys(this.props.close_banner).length > 0 && (!this.props.close_banner[closeBannerCookie] || typeof this.props.close_banner[closeBannerCookie] == 'undefined'))) && <CffBanner type="mobile" condition={cookieCondition} />}
          </div>
        </header>
        <ChallengingModal
          open={this.open}
          location={this.props.location}
          history={this.props.history}
        />
        <LoginComponent
          open={this.open}
          location={this.props.location}
          history={this.props.history}
        />
        <ForgotPasswordComponent
          open={this.open}
          location={this.props.location}
          history={this.props.history}
        />
        <WorkoutSchedulePopup
          location={this.props.location}
          history={this.props.history}
        />

        <Modal
          className="removebbg-popup"
          open={this.state.maintance_model}
          onClose={this.onCloseModal}
          center
        >

          <div
            className="modal-dialog schedule_block welcome-popup common_design modal-width--custom"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header header-styling  border-0">
                <h5
                  className="modal-title1 text-center col-md-12 p-0  font-semibold white-txt"
                  id="exampleModalLabel font-medium"
                >
                  Welcome to Kidney Beam!
                </h5>

                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span
                    aria-hidden="true"
                    onClick={() => this.maintance_model_state(false)}
                  >
                    &times;
                  </span>
                </button>
              </div>
              <div className="modal-body pb-0">
                <img
                  className="img-fluid wel-center-img"
                  src={constand.WEB_IMAGES + "welocome_image.png"}
                ></img>

                <p className="font-book black-txt text-center mx-auto w-75 font-15 font-normal">
                  We are super excited to have launched our new brand and
                  platform.
                </p>
                <p className="font-book black-txt text-center mx-auto w-75 font-15 font-normal">
                  If you who knew us before as Pactster get comfy. This is your
                  new home.
                </p>
                <p className="font-book black-txt text-center mx-auto w-75 font-15 font-normal">
                  If you're a completely new user, we're thrilled to have you
                  join us at such an exiting time.
                </p>
                <p className="font-book black-txt text-center mx-auto w-75 font-15 font-normal">
                  Kidney Beam Team, let's do this!!
                </p>
                <div className="col-md-12">
                  <div className="row">
                    <div className="col-md-12">
                      <a
                        className="btn btn-login btn-blue-inverse w-100 mx-auto m-b-10 m-t-20 color-blue font-medium "
                        href="https://beamfeelgood.com/resources/news"
                      >
                        {" "}
                        Read more about the rebrand{" "}
                        {/*{" "}Take me to Pactster{" "}*/}
                      </a>

                      <button
                        className="btn btn-login w-100  mx-auto m-b-30 font-14"
                        onClick={() => this.maintance_model_state(false)}
                      >
                        {/*
                  {" "}
                  Continue{" "}*/}{" "}
                        Continue on Kidney Beam{" "}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>

        <ConfirmationPopup
          is_model_open={this.props.is_policy_open}
          type='policy'
          isConfirmation={false}
          isCloseRequired={false}
          title="Hold your horses - our policies have changed!"
          closeConfirmationPopup={(terms) => this.saveUserPolicy(terms)}
          handleCheckboxChange={(e) => this.handleCheckboxChange(e)}
          submitted={this.state.submitted}
          terms={this.state.terms}
          hasButton={true}
        />
        {/* SwitchAccountPopup */}
        {this.props.is_switch_account_open && <ConfirmationPopup
          is_model_open={this.props.is_switch_account_open}
          isConfirmation={false}
          type='SwitchAccountPopup'
          isSwitchAccount={true}
          isCloseRequired={true}
          getHealthCondition={() => this.getConditions()}
          title="Which profile do you want to view?"
          hasButton={false}
          history={this.props.history}
        />
        }
        {/* Condition popup */}
        <ConditionalModalComponent
          isModalOpen={this.props.is_condition_model_open}
          getConditionPopup={this.getConditionPopup}
          pageUrl={this.state.pageUrl}
          closeConditionModal={this.closeConditionModal}
          from="header"
        />

        {/* Landing popup after signup */}
        {!this.props.is_fitness_test_model_open && this.props.is_new_user && this.state.showLandingPopup && <LandingModalComponent
          isModalOpen={this.props.is_new_user && !this.props.init_condition.includes('research')}
          condition={this.props.init_condition}
          userDetails={this.props.logged_userData}
          type="landing"
          hasButton={false}
          history={this.props.history}
        />}

        {/* kd clininc selection */}
        <ClinicConfirmationPopup
          is_model_open={this.props.is_clinic_model_open}
          title="To continue being able to offer Kidney Beam for free throughout the UK we need to know which renal unit you are associated with. Please choose from the list below..."
          isCloseRequired={false}
        />
        {/* Test Landing popup after signup */}
        <LandingModalComponent
          isModalOpen={this.props.is_fitness_test_model_open}
          condition={this.props.init_condition}
          userDetails={this.props.logged_userData}
          type="fitness"
          hasButton={true}
          history={this.props.history}
        />

        {/* post clinicians session popup */}
        {this.props.is_clinician_session && <ClinicianSessionPopup
          is_model_open={this.props.is_clinician_post_session_popup}
          title="Thanks for running a group session!"
          isCloseRequired={true}
          type={"postSession"}
          history={this.props.history}
        />}
      </React.Fragment >
    );
  }
}

const mapStateToProps = state => {

  return {
    is_auth: state.auth.is_auth,
    logged_userData: state.header.logged_userData,
    notification: state.header.notification_data.notification,
    userDetails: state.header.notification_data.userDetails,
    healthcondition_list: state.register.healthcondition_list,
    warning_banner_text: state.register.warning_banner_text,
    init_condition: state.auth.initial_condition,
    menu_condition: state.auth.menu_condition,
    IP_Details: state.accountinfo.ip_data,
    close_banner: state.header.close_banner,
    close_banner_kd: state.header.close_banner_kd,
    is_create_mode: state.header.is_create_mode,
    is_group_mode: state.header.is_group_mode,
    is_group_admin: state.group.is_group_admin,
    is_group_leader: state.group.is_group_leader,
    close_banner_pc: state.header.close_banner_pc,
    explore_conditions: state.accountinfo.explore_conditions,
    beamer_filter: state.header.beamer_filter,
    is_menu_has_data: state.header.is_menu_has_data,
    is_policy_open: state.header.is_policy_open,
    is_new_user: state.register.is_new_user,
    module_data: state.header.module_data,
    url_condition: state.header.url_condition,
    is_clinic_model_open: state.header.is_clinic_model_open,
    is_switch_account_open: state.header.is_switch_account_open,
    master_user_details: state.header.master_user_details,
    teens_on_beam_details: state.header.teens_on_beam_details,
    is_fitness_test_model_open: state.dashboard.is_fitness_test_model_open,
    is_condition_model_open: state.header.is_condition_model_open,
    userTestScoreList: state.dashboard.userTestScoreList,
    is_test_taken_today: state.header.is_test_taken_today,
    is_clinician_session: state.header.is_clinician_session,
    is_clinician_post_session_popup: state.header.is_clinician_post_session_popup,
  };
};

const mapDispatchToProps = {
  loginModelOpen,
  isAuth,
  logout,
  fetchUserDetails,
  start_loader,
  stop_loader,
  updateUserdataRedex,
  setCondition,
  setMenuCondition,
  healthCondition,
  fetchNotifications,
  readNotifications,
  confirmNotifications,
  updateNotification,
  warningBanner,
  changeCMSMode,
  updateUserChallengeTag,
  changeCMSGroupMode,
  getFooter,
  getFeatures,
  fetchConditionRelationships,
  setExploreConditions,
  gotoStep,
  clearRegisterFormUpdate,
  checkMenuData,
  openPolicy,
  savePolicy,
  getCountriesList,
  getCountOfData,
  getFaqContent,
  getURLCondition,
  switchAccount,
  fetchUserOtherDetails,
  masterUserDetails,
  teensOnBeam,
  isTakeTestClicked,
  fitnessTestForm,
  fitnessTestModalOpen,
  getUserFitnessTestScore,
  conditionModel,
  isClinicianSession,
  getConditionBanner,
  getBlogTags,
  getBlogsTitle
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Header);